(function () {
  // ============================================
  // Constants & Configuration
  // ============================================

  // const AUTH_SECRET = "pifi_auth_secret_2024_change_this_in_production"; // test
  const AUTH_SECRET = "6MZYng0heWG82slayuNXHKQvHMLpbl05"; // prod

  const API_CONFIG = {
    // WebSocket 接口
    /* test环境 */
    // WS_URL: "wss://test-bigdata-momo-pifi-customer.mypifi.com/api/ws/chat",
    /* dev环境,需要后端本地启动服务 */
    // WS_URL: "ws://172.16.24.205:23063/api/ws/chat", // li
    // WS_URL: "ws://172.16.50.226:23063/api/ws/chat", //yang
    /* prod环境 */
    WS_URL: "wss://bigdata-momo-pifi-customer.mypifi.com/api/ws/chat",

    // 上传附件 接口
    /* test环境 */
    // UPLOAD_URL: "https://test-bigdata-momo-pifi-customer.mypifi.com/task/upload",
    /* dev环境,需要后端本地启动服务 */
    // UPLOAD_URL: "http://172.16.24.205:23063/task/upload", // li
    // UPLOAD_URL: "http://172.16.50.226:23063/task/upload", //yang
    /* prod环境 */
    UPLOAD_URL: "https://bigdata-momo-pifi-customer.mypifi.com/task/upload",
  };

  const CONFIG = {
    HEARTBEAT_INTERVAL: 20000, // 心跳间隔 20 秒
    HEARTBEAT_TIMEOUT: 10000, // 心跳超时 10 秒
    HEARTBEAT_MAX_FAILURES: 5, // 心跳连续失败最大次数，达到此次数才关闭连接
    RECONNECT_INTERVAL_BASE: 1000, // 重连基础间隔 1 秒
    RECONNECT_INTERVAL_MAX: 30000, // 重连最大间隔 30 秒
    MAX_RECONNECT_ATTEMPTS: 5, // 最大重连次数
    REQUEST_TIMEOUT: 10000, // HTTP 请求超时
    MESSAGE_BATCH_DELAY: 100, // 消息批量渲染延迟
  };

  const WS_MESSAGE_TYPE = {
    // 客户端发送
    MESSAGE: "message",
    PING: "ping",
    ACK: "ack",
    TYPING: "typing",

    // 服务端发送
    PONG: "pong",
    SYSTEM: "system",
    ERROR: "error",
    CONNECTION_SUCCESS: "connection_success",
  };

  const WS_STATE = {
    CONNECTING: "connecting",
    CONNECTED: "connected",
    DISCONNECTED: "disconnected",
    RECONNECTING: "reconnecting",
  };

  const ERROR_MESSAGES = {
    INIT_FAILED: "Connection failed, please check your network and try again",
    WS_CONNECTION_FAILED: "Failed to connect to chat service",
    WS_CONNECTION_LOST: "Connection lost, reconnecting...",
    WS_RECONNECT_FAILED: "Unable to reconnect, please refresh the page",
    NETWORK_ERROR: "Network connection error",
    SEND_MESSAGE_FAILED: "Failed to send message, please try again",
  };

  const FORM_VALIDATION_RULES = {
    EMAIL: {
      pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
      message: "Please enter a valid email address",
    },
    PHONE: {
      pattern: /^[\d\s\-\+\(\)]+$/,
      message: "Please enter a valid phone number",
    },
    URL: {
      pattern: /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/,
      message: "Please enter a valid URL",
    },
    NUMBER: {
      pattern: /^\d+$/,
      message: "Please enter a valid number",
    },
    TEXT: {
      pattern: /^[\s\S]+$/,
      message: "Please enter a valid text",
    },
    RADIO: {
      pattern: /^.+$/,
      message: "Please select an option",
    },
  };

  const STORAGE_KEYS = {
    CHAT_GUEST_ID: "momo-chat-guest-id",
    CHAT_USER_ID: "momo-chat-user-id",
    LAST_MESSAGE_ID: "momo-chat-last-message-id",
    LAST_MESSAGE_TIME: "momo-chat-last-message-time",
  };

  const FILE_VALIDATION = {
    IMAGE: {
      FORMATS: ["image/jpeg", "image/png", "image/webp"],
      MAX_SIZE: 20 * 1024 * 1024, // 20MB
      EXTENSIONS: [".jpg", ".jpeg", ".png", ".webp"],
      ACCEPT: "image/jpeg,image/png,image/webp",
    },
    VIDEO: {
      FORMATS: ["video/mp4", "video/quicktime"],
      MAX_SIZE: 100 * 1024 * 1024, // 100MB
      EXTENSIONS: [".mp4", ".mov"],
      ACCEPT: "video/mp4,video/quicktime",
    },
  };

  // ============================================
  // File Validation & Upload
  // ============================================

  // 添加上传动画样式（如果不存在）
  if (!document.getElementById("chat-upload-animation-style")) {
    const style = document.createElement("style");
    style.id = "chat-upload-animation-style";
    style.textContent = `
      .chat-form-file__loading-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
      }
    `;
    document.head.appendChild(style);
  }

  /**
   * 判断文件类型
   * @param {File} file - 文件对象
   * @returns {string} 'image' | 'video' | 'unknown'
   */
  const getFileType = (file) => {
    if (FILE_VALIDATION.IMAGE.FORMATS.includes(file.type)) {
      return "image";
    }
    if (FILE_VALIDATION.VIDEO.FORMATS.includes(file.type)) {
      return "video";
    }
    return "unknown";
  };

  /**
   * 验证图片文件
   * @param {File} file - 文件对象
   * @returns {Object} { valid: boolean, message: string }
   */
  const validateImageFile = (file) => {
    // 检查文件类型
    if (!FILE_VALIDATION.IMAGE.FORMATS.includes(file.type)) {
      return {
        valid: false,
        message: "Please upload an image file (JPEG, PNG, or WebP)",
      };
    }

    // 检查文件大小
    if (file.size > FILE_VALIDATION.IMAGE.MAX_SIZE) {
      return {
        valid: false,
        message: "Image file size must be less than 20MB",
      };
    }

    return { valid: true, message: "" };
  };

  /**
   * 验证视频文件
   * @param {File} file - 文件对象
   * @returns {Object} { valid: boolean, message: string }
   */
  const validateVideoFile = (file) => {
    // 检查文件类型
    if (!FILE_VALIDATION.VIDEO.FORMATS.includes(file.type)) {
      return {
        valid: false,
        message: "Please upload a video file (MP4 or MOV)",
      };
    }

    // 检查文件大小
    if (file.size > FILE_VALIDATION.VIDEO.MAX_SIZE) {
      return {
        valid: false,
        message: "Video file size must be less than 100MB",
      };
    }

    return { valid: true, message: "" };
  };

  /**
   * 验证文件
   * @param {File} file - 文件对象
   * @param {boolean} allowVideo - 是否允许视频
   * @returns {Object} { valid: boolean, message: string, fileType: string }
   */
  const validateFile = (file, allowVideo = false) => {
    const fileType = getFileType(file);

    if (fileType === "unknown") {
      return {
        valid: false,
        message: allowVideo
          ? "Please upload an image (JPEG, PNG, WebP) or video (MP4, MOV) file"
          : "Please upload an image file (JPEG, PNG, or WebP)",
        fileType: "unknown",
      };
    }

    if (fileType === "image") {
      const result = validateImageFile(file);
      return { ...result, fileType: "image" };
    }

    if (fileType === "video") {
      if (!allowVideo) {
        return {
          valid: false,
          message: "Video files are not allowed here",
          fileType: "video",
        };
      }
      const result = validateVideoFile(file);
      return { ...result, fileType: "video" };
    }

    return { valid: false, message: "Invalid file type", fileType: "unknown" };
  };

  /**
   * 上传文件到服务器
   * @param {File} file - 文件对象
   * @param {string} fileType - 文件类型 'image' | 'video'
   * @returns {Promise<string>} oss_url
   */
  const uploadFileToServer = async (file, fileType) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("file_type", fileType);

      // 添加 user_id（如果有）
      if (ChatState.userId) {
        formData.append("user_id", ChatState.userId);
      }

      // 已登录用户：添加 auth_token
      if (
        ChatState.tokenManager &&
        window.shopifyCustomer &&
        window.shopifyCustomer.isLoggedIn
      ) {
        const token = await ChatState.tokenManager.getToken();
        formData.append("auth_token", token);
      }

      const response = await fetch(API_CONFIG.UPLOAD_URL, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Upload failed: ${response.status}`);
      }

      const result = await response.json();

      if (result.success && result.data && result.data.oss_url) {
        return result.data.oss_url;
      } else {
        throw new Error(result.message || "Upload failed");
      }
    } catch (error) {
      console.error("[Upload] Upload error:", error);
      throw error;
    }
  };

  // ============================================
  // Token Management
  // ============================================

  /**
   * 使用 Web Crypto API 计算 HMAC-SHA256
   * @param {string} message - 待签名的消息
   * @param {string} secret - 密钥
   * @returns {Promise<string>} 十六进制签名字符串
   */
  const hmacSHA256 = async (message, secret) => {
    const encoder = new TextEncoder();
    const keyData = encoder.encode(secret);
    const messageData = encoder.encode(message);

    // 导入密钥
    const key = await crypto.subtle.importKey(
      "raw",
      keyData,
      { name: "HMAC", hash: "SHA-256" },
      false,
      ["sign"]
    );

    // 计算签名
    const signature = await crypto.subtle.sign("HMAC", key, messageData);

    // 转换为十六进制字符串
    const hashArray = Array.from(new Uint8Array(signature));
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");

    return hashHex;
  };

  /**
   * 生成认证 Token
   * @param {string} userId - 用户ID
   * @returns {Promise<string>} token 字符串，格式: timestamp:signature
   */
  const generateAuthToken = async (userId) => {
    // 1. 获取当前时间戳（秒）
    const timestamp = Math.floor(Date.now() / 1000);

    // 2. 构建签名字符串
    const message = userId + timestamp;

    // 3. 计算 HMAC-SHA256 签名
    const signature = await hmacSHA256(message, AUTH_SECRET);

    // 4. 组合 Token
    return `${timestamp}:${signature}`;
  };

  /**
   * Token 管理类
   */
  class TokenManager {
    constructor(userId) {
      this.userId = userId;
      this.token = null;
      this.tokenExpiry = 0;
    }

    /**
     * 获取 Token（自动刷新）
     */
    async getToken() {
      const now = Math.floor(Date.now() / 1000);
      // 如果 Token 不存在或将在 60 秒内过期，重新生成
      if (!this.token || this.tokenExpiry - now < 60) {
        await this.refreshToken();
      }
      return this.token;
    }

    /**
     * 刷新 Token
     */
    async refreshToken() {
      this.token = await generateAuthToken(this.userId);
      // Token 有效期 5 分钟，提前 1 分钟刷新
      this.tokenExpiry = Math.floor(Date.now() / 1000) + 240;
    }

    /**
     * 检查 Token 是否有效
     */
    isValid() {
      if (!this.token) return false;
      const now = Math.floor(Date.now() / 1000);
      return this.tokenExpiry - now > 0;
    }
  }

  // ============================================
  // Chat State Management
  // ============================================

  const ChatState = {
    // 基础状态
    isInitialized: false,
    isInitializing: false,
    hasEverInitialized: false, // 是否曾经成功初始化过（用于区分真正的初次建联和正常断联后的重连）
    userId: null,
    tokenManager: null,
    hasShownWelcomeMessage: false, // 是否已显示欢迎消息

    // WebSocket 相关
    ws: null,
    wsState: WS_STATE.DISCONNECTED,
    reconnectAttempts: 0,
    reconnectTimer: null,
    heartbeatTimer: null,
    heartbeatTimeoutTimer: null,
    lastHeartbeatTime: null,
    heartbeatFailureCount: 0, // 心跳连续失败次数
    faqMessages: new Map(),

    // 消息相关
    lastMessageId: null,
    lastMessageTime: null,
    displayedMessageIds: new Set(),
    messageQueue: [],
    pendingMessages: new Map(),
  };

  // 表单状态管理
  const FormState = {
    currentFormId: null,
    currentStep: 0,
    formData: {},
    fields: [],
    isSubmitting: false,
    cardId: null,
    buttonAction: null,
    cardData: {},
  };

  const resetChatState = () => {
    ChatState.isInitialized = false;
    ChatState.isInitializing = false;
    ChatState.hasEverInitialized = false; // 重置时也清除此标志
    ChatState.reconnectAttempts = 0;
    closeWebSocket();
  };

  // ============================================
  // LocalStorage Utilities
  // ============================================

  const getChatGuestId = () => {
    try {
      return localStorage.getItem(STORAGE_KEYS.CHAT_GUEST_ID) || null;
    } catch (e) {
      console.error("Failed to read guest_id from localStorage:", e);
      return null;
    }
  };

  const setChatGuestId = (guestId) => {
    try {
      if (guestId) {
        localStorage.setItem(STORAGE_KEYS.CHAT_GUEST_ID, guestId);
      }
    } catch (e) {
      console.error("Failed to write guest_id to localStorage:", e);
    }
  };

  const clearChatGuestId = () => {
    try {
      localStorage.removeItem(STORAGE_KEYS.CHAT_GUEST_ID);
    } catch (e) {
      console.error("Failed to clear guest_id from localStorage:", e);
    }
  };

  const getLastMessageInfo = () => {
    try {
      return {
        messageId: localStorage.getItem(STORAGE_KEYS.LAST_MESSAGE_ID) || null,
        timestamp:
          parseInt(localStorage.getItem(STORAGE_KEYS.LAST_MESSAGE_TIME)) ||
          null,
      };
    } catch (e) {
      console.error("Failed to read message info from localStorage:", e);
      return { messageId: null, timestamp: null };
    }
  };

  const setLastMessageInfo = (messageId, timestamp) => {
    try {
      if (messageId) {
        localStorage.setItem(STORAGE_KEYS.LAST_MESSAGE_ID, messageId);
      }
      if (timestamp) {
        localStorage.setItem(
          STORAGE_KEYS.LAST_MESSAGE_TIME,
          timestamp.toString()
        );
      }
    } catch (e) {
      console.error("Failed to write message info to localStorage:", e);
    }
  };

  // ============================================
  // User ID Management
  // ============================================

  /**
   * 处理后端返回的 user_id
   * @param {string} userId - 后端返回的用户ID
   */
  const handleUserIdFromBackend = (userId) => {
    if (!userId) return;

    // 判断当前登录状态
    const isLoggedIn =
      window.shopifyCustomer && window.shopifyCustomer.isLoggedIn;

    if (isLoggedIn) {
      // 已登录用户：删除 localStorage 中的访客 ID
      clearChatGuestId();
      ChatState.userId = userId;
    } else {
      // 未登录用户：存储访客 ID 到 localStorage
      setChatGuestId(userId);
      ChatState.userId = userId;
    }
  };

  // ============================================
  // WebSocket Connection Management
  // ============================================

  const createWebSocket = () => {
    // 获取用户 ID
    let userId = null;
    if (window.shopifyCustomer && window.shopifyCustomer.isLoggedIn) {
      // 已登录用户：使用真实用户 ID
      userId = window.shopifyCustomer.id
        ? String(window.shopifyCustomer.id)
        : null;
    } else {
      // 未登录用户：从 localStorage 获取访客 ID（如果有）
      userId = getChatGuestId();
    }

    // 更新 ChatState
    ChatState.userId = userId;

    // 初始化 TokenManager（仅已登录用户）
    if (userId && window.shopifyCustomer && window.shopifyCustomer.isLoggedIn) {
      ChatState.tokenManager = new TokenManager(userId);
    } else {
      ChatState.tokenManager = null;
    }

    // 使用纯净的 WebSocket URL（不带参数）
    const wsUrl = API_CONFIG.WS_URL;

    const ws = new WebSocket(wsUrl);
    return ws;
  };

  const connectWebSocket = () => {
    if (ChatState.ws && ChatState.ws.readyState === WebSocket.OPEN) {
      return;
    }

    if (ChatState.wsState === WS_STATE.CONNECTING) {
      return;
    }

    try {
      // 重置连接相关状态，允许重连后接收历史消息
      ChatState.displayedMessageIds.clear();
      ChatState.lastHeartbeatTime = null;

      ChatState.wsState = WS_STATE.CONNECTING;
      updateConnectionStatus("Connecting...");

      const ws = createWebSocket();
      ChatState.ws = ws;

      ws.onopen = handleWebSocketOpen;
      ws.onmessage = handleWebSocketMessage;
      ws.onerror = handleWebSocketError;
      ws.onclose = handleWebSocketClose;
    } catch (error) {
      console.error("[WebSocket] Failed to create connection:", error);
      handleConnectionError(error);
    }
  };

  const closeWebSocket = () => {
    stopHeartbeat();
    stopReconnect();

    if (ChatState.ws) {
      try {
        ChatState.ws.close(1000, "Client closed");
      } catch (e) {
        console.error("[WebSocket] Error closing connection:", e);
      }
      ChatState.ws = null;
    }

    ChatState.wsState = WS_STATE.DISCONNECTED;
  };

  /**
   * 等待 WebSocket 连接建立
   * @param {number} timeout - 超时时间（毫秒），默认5000ms
   * @returns {Promise<boolean>} 连接是否成功建立
   */
  const waitForConnection = async (timeout = 5000) => {
    // 如果已经连接，直接返回
    if (
      ChatState.wsState === WS_STATE.CONNECTED &&
      ChatState.ws &&
      ChatState.ws.readyState === WebSocket.OPEN
    ) {
      return true;
    }

    const startTime = Date.now();
    while (Date.now() - startTime < timeout) {
      if (
        ChatState.wsState === WS_STATE.CONNECTED &&
        ChatState.ws &&
        ChatState.ws.readyState === WebSocket.OPEN
      ) {
        return true;
      }
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    return false;
  };

  const sendWebSocketMessage = async (type, data) => {
    if (!ChatState.ws || ChatState.ws.readyState !== WebSocket.OPEN) {
      console.warn("[WebSocket] Cannot send message, not connected");

      // 如果是用户消息，加入队列
      if (type === WS_MESSAGE_TYPE.MESSAGE) {
        ChatState.messageQueue.push({ type, data });
        showError(ERROR_MESSAGES.WS_CONNECTION_LOST, false);
      }

      return false;
    }

    try {
      const messageData = {
        type,
        ...data,
      };

      // 添加 user_id（必需）
      if (ChatState.userId) {
        messageData.user_id = ChatState.userId;
      } else {
        console.warn("[WebSocket] No user_id available, message may fail");
      }

      // 已登录用户：添加 auth_token
      if (
        ChatState.tokenManager &&
        window.shopifyCustomer &&
        window.shopifyCustomer.isLoggedIn
      ) {
        const token = await ChatState.tokenManager.getToken();
        messageData.auth_token = token;
      }

      const message = JSON.stringify(messageData);
      ChatState.ws.send(message);
      return true;
    } catch (error) {
      console.error("[WebSocket] Failed to send message:", error);
      showError(ERROR_MESSAGES.SEND_MESSAGE_FAILED, false);
      return false;
    }
  };

  // ============================================
  // WebSocket Event Handlers
  // ============================================

  const handleWebSocketOpen = async (event) => {
    ChatState.wsState = WS_STATE.CONNECTED;
    ChatState.reconnectAttempts = 0;

    hideError();
    updateConnectionStatus("Connected");

    // 立即发送握手消息
    await sendHandshakeMessage();

    // 启动心跳
    // TODO://
    startHeartbeat();

    // 发送队列中的消息
    flushMessageQueue();

    // 同步离线期间的消息
    syncOfflineMessages();
  };

  /**
   * 发送握手消息
   */
  const sendHandshakeMessage = async () => {
    try {
      const handshakeData = {
        type: "handshake",
      };

      // 根据是否是真正的初次建联来决定是否需要历史记录
      // 如果 hasEverInitialized 为 false，说明是真正的初次建联，需要历史记录
      // 如果 hasEverInitialized 为 true，说明曾经初始化过（包括正常断联后的重连），不需要历史记录
      handshakeData.is_need_history = !ChatState.hasEverInitialized;

      const isLoggedIn =
        window.shopifyCustomer && window.shopifyCustomer.isLoggedIn;

      if (isLoggedIn && ChatState.userId) {
        // 已登录用户：添加 user_id 和 auth_token
        handshakeData.user_id = ChatState.userId;

        // 生成 token
        if (ChatState.tokenManager) {
          const token = await ChatState.tokenManager.getToken();
          handshakeData.auth_token = token;
        }

        // 如果有访客 ID，添加 guest_id
        const guestId = getChatGuestId();
        if (guestId) {
          handshakeData.guest_id = guestId;
        }
      } else if (ChatState.userId) {
        // 未登录但有访客 ID：只添加 user_id（访客ID）
        handshakeData.user_id = ChatState.userId;
      }

      // 发送握手消息
      if (ChatState.ws && ChatState.ws.readyState === WebSocket.OPEN) {
        const message = JSON.stringify(handshakeData);
        ChatState.ws.send(message);
      }
    } catch (error) {
      console.error("[Handshake] Failed to send handshake message:", error);
    }
  };

  const handleWebSocketMessage = (event) => {
    try {
      const message = JSON.parse(event.data);

      // 处理握手响应
      if (message.message_type === "handshake") {
        handleHandshakeResponse(message);
        return;
      }

      // 处理握手错误
      if (message.message_type === "handshake_error") {
        handleHandshakeError(message);
        return;
      }

      // 处理 ping 响应（pong）
      if (message.message_type === "ping") {
        handlePongMessage(message);
        return;
      }

      // 处理文本消息
      if (message.message_type === "text") {
        handleTextMessage(message);
        return;
      }

      // 处理 FAQ 消息
      if (message.message_type === "faq") {
        handleFaqMessage(message);
        return;
      }

      // 处理 information 消息（表单收集）
      if (message.message_type === "information") {
        handleInformationMessage(message);
        return;
      }

      // 处理 confirm 消息
      if (message.message_type === "confirm") {
        handleConfirmMessage(message);
        return;
      }

      // 处理图片消息
      if (message.message_type === "image") {
        handleImageMessage(message);
        return;
      }

      // 处理链接消息
      if (message.message_type === "link") {
        handleLinkMessage(message);
        return;
      }

      // 处理所有消息中的 user_id（如果有）
      if (message.user_id) {
        handleUserIdFromBackend(message.user_id);
      }

      switch (message.type) {
        case WS_MESSAGE_TYPE.CONNECTION_SUCCESS:
          handleConnectionSuccess(message.data);
          break;

        case WS_MESSAGE_TYPE.MESSAGE:
          handleIncomingMessage(message.data);
          break;

        case WS_MESSAGE_TYPE.SYSTEM:
          handleSystemMessage(message.data);
          break;

        case WS_MESSAGE_TYPE.ERROR:
          handleErrorMessage(message.data);
          break;

        case WS_MESSAGE_TYPE.ACK:
          handleAckMessage(message.data);
          break;

        default:
          console.warn("[WebSocket] Unknown message type:", message.type);
      }
    } catch (error) {
      console.error("[WebSocket] Failed to parse message:", error);
    }
  };

  /**
   * 处理握手响应
   * @param {Object} message - 握手响应消息
   */
  const handleHandshakeResponse = (message) => {
    // 检查握手是否成功
    const isSuccess = message.content && message.content.success === true;

    if (isSuccess) {
      // 提取并处理 user_id
      if (message.user_id) {
        handleUserIdFromBackend(message.user_id);
      }

      // 握手成功后隐藏加载动画
      hideLoading();

      // 隐藏重连状态提示（如果存在）
      hideReconnectStatus();

      // 握手成功后，标记为已初始化
      ChatState.isInitialized = true;
      // 标记为曾经成功初始化过（用于区分真正的初次建联和正常断联后的重连）
      ChatState.hasEverInitialized = true;

      // 在对话框最上方显示连接成功的系统消息（仅在初次初始化时显示）
      // 重连时不显示欢迎消息，避免打扰用户
      if (!ChatState.hasShownWelcomeMessage) {
        addMessageAtTop("system", "system", {
          content: "Welcome! How can I help?",
        });
        ChatState.hasShownWelcomeMessage = true;
      }
    } else {
      // 握手失败，显示错误消息
      console.error("[Handshake] Handshake failed:", message);

      const errorMessage =
        message.content && message.content.text
          ? message.content.text
          : "Handshake failed, please try again";

      showError(errorMessage, true);
      hideLoading();
    }
  };

  /**
   * 处理握手错误消息
   * @param {Object} message - 握手错误消息
   * 格式：
   * {
   *   "message_type": "handshake_error",
   *   "error_code": "AUTH_FAILED",
   *   "message": "Authentication failed",
   *   "reason": "Token verification failed"
   * }
   */
  const handleHandshakeError = (message) => {
    console.error("[Handshake] Handshake error received:", message);

    // 错误码对应的用户友好提示
    const ERROR_CODE_MESSAGES = {
      HANDSHAKE_TIMEOUT: "Connection timeout, please try again",
      INVALID_HANDSHAKE: "Connection failed, please refresh the page",
      AUTH_FAILED: "Authentication failed, please login again",
      MISSING_TOKEN: "Authentication required, please login",
      INVALID_JSON: "Connection error, please try again",
    };

    // 获取错误码和消息
    const errorCode = message.error_code || "UNKNOWN";
    const errorMessage = message.message || "Connection failed";
    const errorReason = message.reason || "";

    // 使用友好的错误提示，如果没有则使用后端返回的消息
    const displayMessage = ERROR_CODE_MESSAGES[errorCode] || errorMessage;

    // 记录详细错误信息
    console.error("[Handshake] Error details:", {
      code: errorCode,
      message: errorMessage,
      reason: errorReason,
    });

    // 显示错误消息，允许重试
    showError(displayMessage, true);
    hideLoading();
    hideReconnectStatus();

    // 标记初始化失败
    ChatState.isInitialized = false;
    ChatState.isInitializing = false;

    // 特殊处理：认证失败时，清除可能过期的 token
    if (errorCode === "AUTH_FAILED" || errorCode === "MISSING_TOKEN") {
      if (ChatState.tokenManager) {
        ChatState.tokenManager.token = null;
        ChatState.tokenManager.tokenExpiry = 0;
        console.log("[Handshake] Token cleared due to auth error");
      }
    }

    // 连接会被服务器关闭，不需要手动关闭
  };

  /**
   * 处理文本消息
   * @param {Object} message - 文本消息
   */
  const handleTextMessage = (message) => {
    // 生成消息唯一ID (使用 timestamp + user_role + content 的组合)
    const messageId = `${message.timestamp}_${message.user_role}_${message.message_type}`;

    // 防止重复显示
    if (ChatState.displayedMessageIds.has(messageId)) {
      return;
    }

    // 提取并处理 user_id
    if (message.user_id) {
      handleUserIdFromBackend(message.user_id);
    }

    // 提取消息内容
    const text =
      message.content && message.content.text ? message.content.text : "";

    if (!text) {
      console.warn("[Message] Empty text message received");
      return;
    }

    // 根据 user_role 确定消息角色
    const role = message.user_role === "assistant" ? "assistant" : "user";

    // 显示文本消息
    addMessage(role, "text", {
      content: text,
      timestamp: message.timestamp, // 传递消息时间戳
    });

    // 标记已显示
    ChatState.displayedMessageIds.add(messageId);
  };

  /**
   * 处理 FAQ 消息
   * @param {Object} message - FAQ 消息
   */
  const handleFaqMessage = (message) => {
    // card_id 在 message 顶层，与 content 同级
    const cardId = message.card_id || "";

    // 生成消息唯一ID
    const messageId = cardId || `${message.timestamp}_${message.message_type}`;

    // 防止重复显示
    if (ChatState.displayedMessageIds.has(messageId)) {
      return;
    }

    // 提取并处理 user_id
    if (message.user_id) {
      handleUserIdFromBackend(message.user_id);
    }

    // 提取 FAQ 内容
    const content = message.content;
    if (!content || !content.questions || !Array.isArray(content.questions)) {
      console.warn("[Message] Invalid FAQ message format");
      return;
    }

    // 显示 FAQ 消息
    addMessage("system", "faq", {
      title: content.title || "FAQ",
      questions: content.questions,
      cardId: cardId, // 使用从 message 顶层提取的 card_id
      timestamp: message.timestamp, // 传递消息时间戳
    });

    // 标记已显示
    ChatState.displayedMessageIds.add(messageId);
  };

  /**
   * 处理 information 消息（表单收集）
   * @param {Object} message - information 消息
   */
  const handleInformationMessage = (message) => {
    // card_id 和 card_data 在 message 顶层，与 content 同级
    const cardId = message.card_id || "";
    const cardData = message.card_data || {};

    // 生成消息唯一ID（使用 card_id）
    const messageId = cardId || `${message.timestamp}_${message.message_type}`;

    // 防止重复显示
    if (ChatState.displayedMessageIds.has(messageId)) {
      return;
    }

    // 提取并处理 user_id
    if (message.user_id) {
      handleUserIdFromBackend(message.user_id);
    }

    // 提取 content 内容
    const content = message.content;
    if (!content || !content.forms || !Array.isArray(content.forms)) {
      console.warn("[Message] Invalid information message format");
      return;
    }

    if (content.forms.length === 0) {
      console.warn("[Message] No forms in information message");
      return;
    }

    // 显示表单消息
    addMessage("assistant", "information", {
      title: content.title || "",
      text: content.text || "",
      cardId: cardId, // 使用从 message 顶层提取的 card_id
      cardData: cardData, // 使用从 message 顶层提取的 card_data
      forms: content.forms,
      buttons: content.buttons || [],
      timestamp: message.timestamp, // 传递消息时间戳
    });

    // 标记已显示
    ChatState.displayedMessageIds.add(messageId);
  };

  /**
   * 处理 confirm 消息
   * @param {Object} message - confirm 消息
   */
  const handleConfirmMessage = (message) => {
    // card_id 和 card_data 在 message 顶层，与 content 同级
    const cardId = message.card_id || "";
    const cardData = message.card_data || {};
    const isEdit = message.is_edit !== false; // 默认为 true，只有明确为 false 时才不可编辑

    // 生成消息唯一ID（使用 card_id）
    const messageId = cardId || `${message.timestamp}_${message.message_type}`;

    // 防止重复显示
    if (ChatState.displayedMessageIds.has(messageId)) {
      return;
    }

    // 提取并处理 user_id
    if (message.user_id) {
      handleUserIdFromBackend(message.user_id);
    }

    // 提取 content 内容
    const content = message.content;
    if (!content || !content.buttons || !Array.isArray(content.buttons)) {
      console.warn("[Message] Invalid confirm message format");
      return;
    }

    // 显示 confirm 消息
    addMessage("assistant", "confirm", {
      title: content.title || "",
      text: content.text || "",
      cardId: cardId, // 使用从 message 顶层提取的 card_id
      cardData: cardData, // 使用从 message 顶层提取的 card_data
      buttons: content.buttons,
      isEdit: isEdit, // 传递 is_edit 字段
      timestamp: message.timestamp, // 传递消息时间戳
    });

    // 标记已显示
    ChatState.displayedMessageIds.add(messageId);
  };

  /**
   * 处理图片消息
   * @param {Object} message - 图片消息
   */
  const handleImageMessage = (message) => {
    // 生成消息唯一ID
    const messageId = `${message.timestamp}_${message.user_role}_${message.message_type}`;

    // 防止重复显示
    if (ChatState.displayedMessageIds.has(messageId)) {
      return;
    }

    // 提取并处理 user_id
    if (message.user_id) {
      handleUserIdFromBackend(message.user_id);
    }

    // 提取 content 内容
    const content = message.content;
    if (!content || !content.oss_url) {
      console.warn("[Message] Invalid image message format: missing oss_url");
      return;
    }

    // 根据 user_role 确定消息角色
    const role = message.user_role === "assistant" ? "assistant" : "user";

    // 显示图片消息
    addMessage(role, "image", {
      title: content.title || "",
      text: content.text || "",
      imageUrl: content.oss_url,
      imageAlt: content.title || "Image",
      timestamp: message.timestamp, // 传递消息时间戳
    });

    // 标记已显示
    ChatState.displayedMessageIds.add(messageId);
  };

  /**
   * 处理链接消息
   * @param {Object} message - 链接消息
   */
  const handleLinkMessage = (message) => {
    // 生成消息唯一ID
    const messageId = `${message.timestamp}_${message.user_role}_${message.message_type}`;

    // 防止重复显示
    if (ChatState.displayedMessageIds.has(messageId)) {
      return;
    }

    // 提取并处理 user_id
    if (message.user_id) {
      handleUserIdFromBackend(message.user_id);
    }

    // 提取 content 内容
    const content = message.content;
    if (!content || !content.link) {
      console.warn("[Message] Invalid link message format: missing link");
      return;
    }

    // 根据 user_role 确定消息角色
    const role = message.user_role === "assistant" ? "assistant" : "user";

    // 显示链接消息
    addMessage(role, "link", {
      linkUrl: content.link,
      timestamp: message.timestamp, // 传递消息时间戳
    });

    // 标记已显示
    ChatState.displayedMessageIds.add(messageId);
  };

  const handleWebSocketError = (event) => {
    console.error("[WebSocket] Connection error:", event);
    console.error("[WebSocket] Error details:", {
      url: ChatState.ws?.url,
      readyState: ChatState.ws?.readyState,
      protocol: window.location.protocol,
    });

    // 检查是否是协议不匹配问题
    if (
      window.location.protocol === "https:" &&
      API_CONFIG.WS_URL.startsWith("ws://")
    ) {
      console.warn(
        "[WebSocket] Warning: HTTPS page trying to connect to WS (insecure). Consider using WSS."
      );
    }

    showError(ERROR_MESSAGES.WS_CONNECTION_FAILED, false);
  };

  const handleWebSocketClose = (event) => {
    ChatState.wsState = WS_STATE.DISCONNECTED;
    stopHeartbeat();

    // WebSocket 关闭代码说明：
    // 1000: 正常关闭（Normal Closure）- 不重连
    // 1001: 端点离开（Going Away）- 通常不需要重连（如服务器重启）
    // 1002-1005: 协议错误 - 需要重连
    // 1006: 异常关闭（Abnormal Closure，无关闭帧）- 需要重连
    // null/undefined: 某些异常情况 - 需要重连

    const code = event.code;

    // 正常关闭（1000）或端点离开（1001），不重连
    if (code === 1000 || code === 1001) {
      // 标记为未初始化，防止页面可见性变化和网络恢复时自动重连
      ChatState.isInitialized = false;

      // 正常关闭时，显示系统消息提示会话已结束
      if (code === 1000) {
        addMessage("system", "system", {
          content: "See you next time!",
        });
      }

      return;
    }

    // 其他情况（异常关闭、协议错误、网络中断等），尝试重连
    // 但如果网络已离线，不重连
    if (!navigator.onLine) {
      return;
    }
    attemptReconnect();
  };

  // ============================================
  // Message Handlers
  // ============================================

  const handleConnectionSuccess = (data) => {
    if (data.userId) {
      handleUserIdFromBackend(data.userId);
    }
  };

  const handleIncomingMessage = (data) => {
    if (!data || !data.id) {
      console.warn("[WebSocket] Invalid message data", data);
      return;
    }

    // 防止重复显示
    if (ChatState.displayedMessageIds.has(data.id)) {
      return;
    }

    // 根据消息类型渲染
    const role = data.role || "assistant";
    const messageType = data.messageType || "text";

    if (messageType === "text") {
      // 文本消息
      addMessage(role, "text", {
        content: data.content,
      });
    } else if (messageType === "faq") {
      // FAQ 消息
      if (data.faqData && data.faqData.questions) {
        // 将 questions 数组转换为 Liquid 期望的格式（用 | 分隔的字符串）
        const questionsString = data.faqData.questions
          .map((q) => q.text)
          .join("|");
        addMessage(role, "faq", {
          questions: questionsString,
        });
      }
    } else if (messageType === "image") {
      // 图片消息
      addMessage(role, "image", {
        content: data.content || "",
        imageUrl: data.imageUrl,
        imageAlt: data.imageAlt || "Image",
      });
    } else if (messageType === "link") {
      // 链接消息
      addMessage(role, "link", {
        url: data.url || "",
        href: data.href || data.url || "",
      });
    } else if (messageType === "form_display") {
      // Form Display 消息
      addMessage(role, "form_display", {
        items: data.items || [],
      });
    } else if (messageType === "form") {
      // Form 表单收集消息
      addMessage(role, "form", {
        fields: data.formData?.fields || [],
      });
    } else if (messageType === "system") {
      // 系统提示消息
      addMessage("system", "system", {
        content: data.content || "",
      });
    }

    // 标记已显示
    ChatState.displayedMessageIds.add(data.id);

    // 更新最后消息信息
    if (data.id && data.timestamp) {
      ChatState.lastMessageId = data.id;
      ChatState.lastMessageTime = data.timestamp;
      setLastMessageInfo(data.id, data.timestamp);
    }
  };

  const handlePongMessage = (message) => {
    ChatState.lastHeartbeatTime = Date.now();

    // 清除心跳超时定时器
    if (ChatState.heartbeatTimeoutTimer) {
      clearTimeout(ChatState.heartbeatTimeoutTimer);
      ChatState.heartbeatTimeoutTimer = null;
    }

    // 收到 pong 响应，重置失败计数
    if (ChatState.heartbeatFailureCount > 0) {
      ChatState.heartbeatFailureCount = 0;
    }

    // pong 消息不展示在对话框中
  };

  const handleSystemMessage = (data) => {
    // TODO: 显示系统消息
  };

  const handleErrorMessage = (data) => {
    console.error("[Server Error]:", data);
    showError(data.message || ERROR_MESSAGES.NETWORK_ERROR, false);
  };

  const handleAckMessage = (data) => {
    // 从待确认列表中移除，并移除 sending 元素
    if (data.clientMessageId) {
      const pendingMessage = ChatState.pendingMessages.get(data.clientMessageId);
      if (pendingMessage && pendingMessage.messageElement) {
        const messageEl = pendingMessage.messageElement;
        const contentEl = messageEl.querySelector(".chat-message__content");
        if (contentEl) {
          const sendingEl = contentEl.querySelector(".chat-message__sending");
          if (sendingEl) {
            sendingEl.remove();
          }
        }
      }
      ChatState.pendingMessages.delete(data.clientMessageId);
    }
  };

  // ============================================
  // Heartbeat Management
  // ============================================

  const startHeartbeat = () => {
    stopHeartbeat();

    // 重置失败计数
    ChatState.heartbeatFailureCount = 0;

    const sendPing = async () => {
      if (ChatState.ws && ChatState.ws.readyState === WebSocket.OPEN) {
        try {
          const pingData = {
            type: "ping",
          };

          // 添加 user_id
          if (ChatState.userId) {
            pingData.user_id = ChatState.userId;
          }

          // 已登录用户：添加 auth_token
          const isLoggedIn =
            window.shopifyCustomer && window.shopifyCustomer.isLoggedIn;
          if (isLoggedIn && ChatState.tokenManager) {
            const token = await ChatState.tokenManager.getToken();
            pingData.auth_token = token;
          }

          // 发送 ping 消息
          if (ChatState.ws && ChatState.ws.readyState === WebSocket.OPEN) {
            const message = JSON.stringify(pingData);
            ChatState.ws.send(message);
          }

          // 设置心跳超时定时器
          ChatState.heartbeatTimeoutTimer = setTimeout(() => {
            ChatState.heartbeatFailureCount++;
            console.warn(
              `[Heartbeat] Timeout (${ChatState.heartbeatFailureCount}/${CONFIG.HEARTBEAT_MAX_FAILURES})`
            );

            // 只有连续失败达到最大次数才关闭连接
            if (
              ChatState.heartbeatFailureCount >= CONFIG.HEARTBEAT_MAX_FAILURES
            ) {
              console.error(
                `[Heartbeat] Max failures reached (${CONFIG.HEARTBEAT_MAX_FAILURES}), closing connection`
              );
              ChatState.ws.close(3000, "Heartbeat timeout");
            }
          }, CONFIG.HEARTBEAT_TIMEOUT);
        } catch (error) {
          console.error("[Heartbeat] Failed to send ping:", error);
        }
      }
    };

    // 立即发送一次
    sendPing();

    // 定时发送
    ChatState.heartbeatTimer = setInterval(sendPing, CONFIG.HEARTBEAT_INTERVAL);
  };

  const stopHeartbeat = () => {
    if (ChatState.heartbeatTimer) {
      clearInterval(ChatState.heartbeatTimer);
      ChatState.heartbeatTimer = null;
    }

    if (ChatState.heartbeatTimeoutTimer) {
      clearTimeout(ChatState.heartbeatTimeoutTimer);
      ChatState.heartbeatTimeoutTimer = null;
    }

    // 重置失败计数
    ChatState.heartbeatFailureCount = 0;
  };

  // ============================================
  // Reconnection Management
  // ============================================

  const attemptReconnect = () => {
    if (ChatState.reconnectAttempts >= CONFIG.MAX_RECONNECT_ATTEMPTS) {
      console.error("[Reconnect] Max attempts reached");
      showError(ERROR_MESSAGES.WS_RECONNECT_FAILED, true);
      ChatState.wsState = WS_STATE.DISCONNECTED;
      return;
    }

    ChatState.reconnectAttempts++;
    ChatState.wsState = WS_STATE.RECONNECTING;

    // 指数退避算法
    const delay = Math.min(
      CONFIG.RECONNECT_INTERVAL_BASE *
        Math.pow(2, ChatState.reconnectAttempts - 1),
      CONFIG.RECONNECT_INTERVAL_MAX
    );

    showError(
      `${ERROR_MESSAGES.WS_CONNECTION_LOST} (Attempt ${ChatState.reconnectAttempts}/${CONFIG.MAX_RECONNECT_ATTEMPTS})`,
      false
    );

    ChatState.reconnectTimer = setTimeout(() => {
      connectWebSocket();
    }, delay);
  };

  const stopReconnect = () => {
    if (ChatState.reconnectTimer) {
      clearTimeout(ChatState.reconnectTimer);
      ChatState.reconnectTimer = null;
    }
    ChatState.reconnectAttempts = 0;
  };

  // ============================================
  // Message Queue Management
  // ============================================

  const flushMessageQueue = async () => {
    if (ChatState.messageQueue.length === 0) {
      return;
    }

    const queue = [...ChatState.messageQueue];
    ChatState.messageQueue = [];

    for (const { type, data } of queue) {
      await sendWebSocketMessage(type, data);
    }
  };

  const syncOfflineMessages = () => {
    // TODO: 如果有离线消息同步接口，在这里调用
    // const lastInfo = getLastMessageInfo();
    // if (lastInfo.messageId) {
    //   fetch(`/api/chat/messages?lastMessageId=${lastInfo.messageId}`)
    //     .then(res => res.json())
    //     .then(data => {
    //       data.messages.forEach(msg => handleIncomingMessage(msg));
    //     });
    // }
  };

  // ============================================
  // Utility Functions
  // ============================================

  const escapeHtml = (text) => {
    const div = document.createElement("div");
    div.textContent = text;
    return div.innerHTML;
  };

  /**
   * 处理文本中的换行符
   * 将字符串 "\n" 转换为真正的换行符 (ASCII 10)
   * 后端可能返回 "Hello\nWorld" 这样的字符串，需要转换为真正的换行
   * @param {string} text - 原始文本
   * @returns {string} 处理后的文本
   */
  const processNewlines = (text) => {
    if (!text) return "";
    // 将 \n 字符串转换为真正的换行符
    // 同时处理 \r\n (Windows) 和 \n (Unix/Mac)
    return text.replace(/\\r\\n/g, "\n").replace(/\\n/g, "\n");
  };

  /**
   * 替换文本中的url为a标签
   * @param {string} text - 原始文本
   * @returns {string} 处理后的文本
   */
  const replaceUrlWithAnchor = (text) => {
    if (!text) return "";
    
    // 匹配 URL 的正则表达式
    const urlRegex = /(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+)/gi;
    
    return text.replace(urlRegex, (match) => {
      // 移除 URL 末尾的常见标点符号（避免链接包含句号、逗号等）
      const cleanUrl = match.replace(/[.,;:!?)\]}>]*$/, '');
      
      // 如果 URL 以 www. 开头，添加 https:// 协议
      const href = cleanUrl.toLowerCase().startsWith('www.') 
        ? `https://${cleanUrl}` 
        : cleanUrl;
      
      // 返回带 target="_blank" 和 rel="noopener noreferrer" 的链接（安全性考虑）
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${cleanUrl}</a>`;
    });
  };

  const scrollToBottom = (smooth = true) => {
    const chatBody = document.querySelector(".customer-chat__body");
    if (chatBody) {
      chatBody.scrollTo({
        top: chatBody.scrollHeight,
        behavior: smooth ? "smooth" : "auto",
      });
    }
  };

  const updateConnectionStatus = (status) => {
    // 加载状态不再显示文字，仅保留旋转图标
  };

  // ============================================
  // UI Rendering Functions
  // ============================================

  /**
   * 统一的消息添加函数 - 使用 DOM 操作填充数据
   * @param {string} role - 消息角色 'assistant' | 'user'
   * @param {string} messageType - 消息类型 'text' | 'image' | 'faq'
   * @param {Object} data - 消息数据，可包含 timestamp 字段（时间戳，毫秒或秒）
   */
  const addMessage = (role, messageType, data = {}) => {
    const chatMessages = document.querySelector(".customer-chat__messages");
    if (!chatMessages) {
      console.error("[addMessage] Chat messages container not found");
      return;
    }

    // 选择模板
    let templateId;
    if (
      messageType === "text" ||
      messageType === "image" ||
      messageType === "link"
    ) {
      templateId = `chat-template-${messageType}-${role}`;
    } else if (messageType === "system") {
      // system 消息不区分角色
      templateId = `chat-template-system`;
    } else if (messageType === "confirm") {
      // confirm 消息只有 assistant 角色
      templateId = `chat-template-confirm`;
    } else if (messageType === "form_display") {
      // form_display 消息只有 assistant 角色
      templateId = `chat-template-form-display`;
    } else {
      templateId = `chat-template-${messageType}`;
    }

    const template = document.getElementById(templateId);
    if (!template) {
      console.error(`[addMessage] Template not found: ${templateId}`);
      return;
    }

    // 克隆模板
    const clone = template.content.cloneNode(true);

    // 使用 DOM 操作填充数据
    if (messageType === "text") {
      const contentEl = clone.querySelector("[data-content-target]");
      if (contentEl) {
        // 处理换行符：将 \n 字符串转换为真正的换行符
        contentEl.innerHTML = replaceUrlWithAnchor(processNewlines(data.content));
      }

      // 设置临时ID（如果提供）
      const messageEl = clone.querySelector(".chat-message");
      if (messageEl && data.tempId) {
        messageEl.setAttribute("data-temp-id", data.tempId);
      }
    } else if (messageType === "system") {
      // 填充系统消息数据
      const contentEl = clone.querySelector("[data-content-target]");
      if (contentEl) {
        // 处理换行符
        contentEl.innerHTML = replaceUrlWithAnchor(processNewlines(data.content));
      }
    } else if (messageType === "image") {
      // 填充图片数据
      const titleEl = clone.querySelector("[data-title-target]");
      const textEl = clone.querySelector("[data-text-target]");
      const imageEl = clone.querySelector("[data-image-target]");
      const imageLinkEl = clone.querySelector("[data-image-link]");

      // 图片消息不显示标题和文本，始终隐藏
      if (titleEl) {
        titleEl.style.display = "none";
      }

      if (textEl) {
        textEl.style.display = "none";
      }

      // 设置图片
      const imageUrl = data.imageUrl || "";
      const imageAlt = data.imageAlt || "Image";

      if (imageEl) {
        imageEl.src = imageUrl;
        imageEl.alt = imageAlt;
      }

      if (imageLinkEl) {
        if (imageUrl) {
          imageLinkEl.href = imageUrl;
        } else {
          imageLinkEl.removeAttribute("href");
        }
      }
    } else if (messageType === "link") {
      // 填充链接数据
      const linkEl = clone.querySelector("[data-link-target]");
      const urlEl = clone.querySelector("[data-url-target]");

      if (linkEl) {
        linkEl.href = data.linkUrl || "#";
      }
      if (urlEl) {
        urlEl.textContent = data.linkUrl || "";
      }
    } else if (messageType === "faq") {
      ChatState.faqMessages.set(data.cardId, data.questions);

      // 填充 FAQ 数据
      // const titleEl = clone.querySelector("[data-title-target]");
      const questionsContainer = clone.querySelector("[data-questions-target]");
      const itemTemplate = clone.querySelector("[data-question-item-template]");

      // // 设置标题（如果有）
      // if (titleEl && data.title) {
      //   titleEl.textContent = data.title;
      // }

      // 设置 card_id（如果有）
      const cardEl = clone.querySelector("[data-card-id]");
      if (cardEl && data.cardId) {
        cardEl.setAttribute("data-card-id", data.cardId);
      }
      console.log(data, 12312312)
      if (questionsContainer && itemTemplate) {
        const questionsArray = data.questions;
        
        // a.forEach((qusItem, index) => {
        questionsArray.forEach((qusItem, index) => {
          const itemClone = itemTemplate.content.cloneNode(true);
          const textEl = itemClone.querySelector("[data-question-text]");
          const buttonEl = itemClone.querySelector("button");

          if (textEl) textEl.textContent = qusItem.text;

          if (buttonEl) {
            buttonEl.setAttribute("data-question", qusItem.text);
            buttonEl.setAttribute("data-question-id", `faq_${index}`);
            buttonEl.setAttribute("data-question-card-id", data.cardId);
          }
          questionsContainer.appendChild(itemClone);
        });
        // 移除模板元素
        itemTemplate.remove();
      }
    } else if (messageType === "confirm") {
      // 填充 Confirm 数据（标题 + 文本 + 按钮组）
      const confirmContainer = clone.querySelector("[data-confirm-container]");
      const titleEl = clone.querySelector("[data-title-target]");
      const textEl = clone.querySelector("[data-text-target]");
      const buttonsContainer = clone.querySelector("[data-buttons-target]");
      const buttonTemplate = clone.querySelector("[data-button-item-template]");

      // 设置卡片数据到容器上
      if (confirmContainer) {
        confirmContainer.setAttribute("data-card-id", data.cardId || "");
        confirmContainer.setAttribute("data-card-type", data.cardType || "");
        confirmContainer.setAttribute(
          "data-card-data",
          JSON.stringify(data.cardData || {})
        );
      }

      // 设置标题（如果存在）
      if (titleEl && data.title) {
        titleEl.textContent = data.title;
        titleEl.style.display = "block";
      }

      // 设置文本内容，处理换行符
      if (textEl) {
        textEl.textContent = processNewlines(data.text || "");
      }

      // 生成按钮
      if (buttonsContainer && buttonTemplate && data.buttons) {
        // 获取 isEdit 字段，默认为 true（可编辑）
        const isEdit = data.isEdit !== false;

        data.buttons.forEach((button) => {
          if (button && button.is_select === false && !isEdit) {
            return;
          }
          const buttonClone = buttonTemplate.content.cloneNode(true);
          const textSpanEl = buttonClone.querySelector("[data-button-text]");
          const buttonEl = buttonClone.querySelector("button");

          if (textSpanEl) textSpanEl.textContent = button.text || "";
          if (buttonEl) {
            buttonEl.setAttribute("data-action", button.action || "");
            buttonEl.setAttribute("data-confirm-button", "true");

            // 根据 is_select 添加选中样式（后端返回布尔值）
            if (button.is_select === true) {
              buttonEl.classList.add("chat-message-confirm__button--selected");
            }

            // 根据 isEdit 设置按钮禁用状态
            if (!isEdit) {
              buttonEl.disabled = true;
              buttonEl.setAttribute("aria-disabled", "true");
            }
          }

          buttonsContainer.appendChild(buttonClone);
        });
        // 移除模板元素
        buttonTemplate.remove();
      }
    } else if (messageType === "form_display") {
      // 填充 Form Display 数据（展示项列表）
      const itemsContainer = clone.querySelector("[data-items-target]");
      const itemTemplate = clone.querySelector("[data-item-template]");

      // 生成展示项
      if (itemsContainer && itemTemplate && data.items) {
        data.items.forEach((item) => {
          const itemClone = itemTemplate.content.cloneNode(true);
          const labelEl = itemClone.querySelector("[data-label-target]");
          const valueEl = itemClone.querySelector("[data-value-target]");

          if (labelEl) labelEl.textContent = item.label || "";
          if (valueEl) valueEl.textContent = item.value || "";

          itemsContainer.appendChild(itemClone);
        });
        // 移除模板元素
        itemTemplate.remove();
      }
    } else if (messageType === "information") {
      // 填充 Information 数据（表单收集）
      const formContainer = clone.querySelector("[data-form-container]");
      const fieldsContainer = clone.querySelector("[data-fields-container]");
      const titleEl = clone.querySelector("[data-form-title]");
      const textEl = clone.querySelector("[data-form-text]");
      const stepText = clone.querySelector("[data-step-text]");
      const buttonEl = clone.querySelector("[data-form-button]");
      const buttonText = clone.querySelector("[data-button-text]");

      if (formContainer && fieldsContainer && data.forms) {
        // 生成表单 ID
        const formId = `form-${Date.now()}-${Math.random()
          .toString(36)
          .substr(2, 9)}`;
        formContainer.setAttribute("data-form-id", formId);

        // 设置 card_id
        if (data.cardId) {
          formContainer.setAttribute("data-card-id", data.cardId);
        }

        // 设置 title（如果有）
        if (titleEl && data.title) {
          titleEl.textContent = data.title;
          titleEl.style.display = "block";
        }

        // 设置 text（如果有）
        if (textEl && data.text) {
          textEl.textContent = data.text;
          textEl.style.display = "block";
        }

        // 初始化表单状态
        FormState.currentFormId = formId;
        FormState.currentStep = 0;
        FormState.fields = data.forms;
        FormState.formData = {};
        FormState.cardId = data.cardId || null;
        FormState.buttonAction = null;
        FormState.cardData = data.cardData || {};

        // 渲染所有字段（初始只显示第一个）
        data.forms.forEach((form, index) => {
          renderFormField(fieldsContainer, form, index, index === 0);
        });

        // 设置按钮的 action 和 card_id
        if (buttonEl && data.buttons && data.buttons.length > 0) {
          const button = data.buttons[0]; // 目前只处理第一个按钮
          if (button.action) {
            buttonEl.setAttribute("data-action", button.action);
          }
          if (data.cardId) {
            buttonEl.setAttribute("data-card-id", data.cardId);
          }
        }

        // 统一使用 updateFormStep 更新步骤显示和按钮文本
        updateFormStep(formContainer, 1, data.forms.length);
      }
    }

    // 添加到页面
    chatMessages.appendChild(clone);
    scrollToBottom();
  };

  /**
   * 在对话框最上方添加消息
   * @param {string} role - 消息角色 'assistant' | 'user' | 'system'
   * @param {string} messageType - 消息类型 'text' | 'image' | 'system' 等
   * @param {Object} data - 消息数据
   */
  const addMessageAtTop = (role, messageType, data = {}) => {
    const chatMessages = document.querySelector(".customer-chat__messages");
    if (!chatMessages) {
      console.error("[addMessageAtTop] Chat messages container not found");
      return;
    }

    // 选择模板（复用 addMessage 的模板选择逻辑）
    let templateId;
    if (
      messageType === "text" ||
      messageType === "image" ||
      messageType === "link"
    ) {
      templateId = `chat-template-${messageType}-${role}`;
    } else if (messageType === "system") {
      // system 消息不区分角色
      templateId = `chat-template-system`;
    } else if (messageType === "confirm") {
      // confirm 消息只有 assistant 角色
      templateId = `chat-template-confirm`;
    } else if (messageType === "form_display") {
      // form_display 消息只有 assistant 角色
      templateId = `chat-template-form-display`;
    } else {
      templateId = `chat-template-${messageType}`;
    }

    const template = document.getElementById(templateId);
    if (!template) {
      console.error(`[addMessageAtTop] Template not found: ${templateId}`);
      return;
    }

    // 克隆模板
    const clone = template.content.cloneNode(true);

    // 使用 DOM 操作填充数据（仅处理 system 消息）
    if (messageType === "system") {
      const contentEl = clone.querySelector("[data-content-target]");
      if (contentEl) {
        // 处理换行符
        contentEl.textContent = processNewlines(data.content);
      }
    }

    // 添加到页面最上方（使用 insertBefore 插入到第一个子元素之前）
    const firstChild = chatMessages.firstChild;
    if (firstChild) {
      chatMessages.insertBefore(clone, firstChild);
    } else {
      // 如果没有子元素，直接添加
      chatMessages.appendChild(clone);
    }
  };

  const showError = (message, showRetry = false) => {
    const errorContainer = document.querySelector(".customer-chat__error");
    const errorMessage = document.querySelector(
      ".customer-chat__error-message"
    );
    const retryButton = document.querySelector(".customer-chat__error-retry");

    if (errorContainer && errorMessage) {
      errorMessage.textContent = message;
      errorContainer.style.display = "flex";

      if (retryButton) {
        retryButton.style.display = showRetry ? "block" : "none";
      }
    }
  };

  const hideError = () => {
    const errorContainer = document.querySelector(".customer-chat__error");
    if (errorContainer) {
      errorContainer.style.display = "none";
    }
  };

  const showLoading = () => {
    const loadingContainer = document.querySelector(".customer-chat__loading");
    if (loadingContainer) {
      loadingContainer.style.display = "flex";
    }
  };

  const hideLoading = () => {
    const loadingContainer = document.querySelector(".customer-chat__loading");
    if (loadingContainer) {
      loadingContainer.style.display = "none";
    }
  };

  /**
   * 显示重连状态提示（轻量级，不遮挡聊天内容）
   * 在输入框上方显示，让用户弱感知重连过程
   */
  const showReconnectStatus = () => {
    // 如果已经存在重连状态提示，先移除
    hideReconnectStatus();

    const chatFooter = document.querySelector(".customer-chat__footer");
    if (!chatFooter) return;

    // 创建一个轻量的连接状态提示元素
    const reconnectStatusEl = document.createElement("div");
    reconnectStatusEl.className = "customer-chat__reconnect-status";
    reconnectStatusEl.setAttribute("data-reconnect-status", "true");
    reconnectStatusEl.innerHTML = `
      <div class="customer-chat__reconnect-status-content">
        <span class="customer-chat__reconnect-status-icon"></span>
        <span class="customer-chat__reconnect-status-text">Reconnecting...</span>                                                                               
      </div>
    `;

    // 插入到输入框上方（footer之前）
    const chatPanel = chatFooter.parentElement;
    if (chatPanel) {
      chatPanel.insertBefore(reconnectStatusEl, chatFooter);
    }
  };

  /**
   * 隐藏重连状态提示
   */
  const hideReconnectStatus = () => {
    const reconnectStatusEl = document.querySelector("[data-reconnect-status]");
    if (reconnectStatusEl) {
      // 添加淡出动画
      reconnectStatusEl.style.opacity = "0";
      reconnectStatusEl.style.transform = "translateY(-10px)";
      setTimeout(() => {
        reconnectStatusEl.remove();
      }, 200);
    }
  };

  /**
   * 渲染单个表单字段
   * @param {HTMLElement} container - 字段容器
   * @param {Object} form - 字段配置
   * @param {number} index - 字段索引
   * @param {boolean} isActive - 是否为当前激活字段
   */
  const renderFormField = (container, form, index, isActive) => {
    const fieldType = form.form_type || form.type;
    const fieldKey = form.key || form.id;

    const templateId = `chat-form-field-${fieldType}`;
    const template = document.getElementById(templateId);
    if (!template) {
      console.error(`[renderFormField] Template not found: ${templateId}`);
      return;
    }

    const clone = template.content.cloneNode(true);
    const fieldEl = clone.querySelector(".chat-form-field");

    // 设置字段属性
    if (fieldEl) {
      fieldEl.setAttribute("data-field-key", fieldKey);
      fieldEl.setAttribute("data-field-index", index);

      // 设置校验规则名称
      if (form.rules?.name) {
        fieldEl.setAttribute("data-rules-name", form.rules.name);
      }

      // 设置显示状态
      if (!isActive) {
        fieldEl.classList.add("chat-form-field--hidden");
      }
    }

    // 设置标题
    const labelEl = clone.querySelector("[data-field-label]");
    if (labelEl) {
      labelEl.textContent = form.label || "";
    }

    // 根据字段类型设置特定属性
    if (fieldType === "input") {
      const inputEl = clone.querySelector("[data-field-input]");
      if (inputEl) {
        inputEl.placeholder = form.placeholder || "";
        if (form.value) inputEl.value = form.value;
        if (form.rules?.require) inputEl.required = true;
        // 添加实时验证：输入时清除错误提示
        inputEl.addEventListener("input", (e) => {
          const formContainer = e.target.closest("[data-form-container]");
          if (formContainer) {
            hideFormError(formContainer);
          }
        });
      }
    } else if (fieldType === "textarea") {
      const textareaEl = clone.querySelector("[data-field-textarea]");
      if (textareaEl) {
        textareaEl.placeholder = form.placeholder || "";
        if (form.value) textareaEl.value = form.value;
        if (form.rows) textareaEl.rows = form.rows;
        if (form.rules?.require) textareaEl.required = true;
        // 添加实时验证：输入时清除错误提示
        textareaEl.addEventListener("input", (e) => {
          const formContainer = e.target.closest("[data-form-container]");
          if (formContainer) {
            hideFormError(formContainer);
          }
        });
      }
    } else if (fieldType === "radio") {
      const radioContainer = clone.querySelector("[data-radio-container]");
      const radioTemplate = clone.querySelector("[data-radio-template]");

      if (radioContainer && radioTemplate && form.options) {
        form.options.forEach((option, optIndex) => {
          const optionClone = radioTemplate.content.cloneNode(true);
          const radioInput = optionClone.querySelector("[data-radio-input]");
          const radioLabel = optionClone.querySelector("[data-radio-label]");

          if (radioInput) {
            radioInput.name = `${fieldKey}-${index}`;
            radioInput.value = option.value || "";
            radioInput.id = `${fieldKey}-${optIndex}`;
            if (form.value === option.value) {
              radioInput.checked = true;
            }
            // 添加实时验证：选择时清除错误提示
            radioInput.addEventListener("change", (e) => {
              const formContainer = e.target.closest("[data-form-container]");
              if (formContainer) {
                hideFormError(formContainer);
              }
            });
          }
          if (radioLabel) {
            radioLabel.textContent = option.label || "";
          }

          radioContainer.appendChild(optionClone);
        });
        radioTemplate.remove();
      }
    } else if (fieldType === "upload") {
      // accept 属性已在模板中固定为图片和视频格式
      // 为 upload 字段元素添加 max 属性（文件数量限制）
      if (fieldEl && form.rules?.max) {
        fieldEl.setAttribute("data-rules-max", form.rules.max);
      }
    }

    container.appendChild(clone);
  };

  /**
   * 验证表单字段
   * @param {Object} form - 字段配置
   * @param {any} value - 字段值
   * @param {string} rulesName - 校验规则名称
   * @returns {Object} - { valid: boolean, message: string }
   */
  const validateFormField = (form, value, rulesName) => {
    const fieldType = form.form_type || form.type;
    const rules = form.rules || {};

    // 必填验证
    if (rules.require) {
      if (fieldType === "upload") {
        // 上传字段：检查是否有文件（数组长度）
        if (!value || !Array.isArray(value) || value.length === 0) {
          return { valid: false, message: "Please upload at least one file" };
        }
      } else if (fieldType === "radio") {
        // 单选字段：检查是否选中
        if (value === null || value === undefined || value === "") {
          return { valid: false, message: "Please select an option" };
        }
      } else {
        // 文本字段：检查是否为空
        if (!value || value.trim().length === 0) {
          return { valid: false, message: "This field is required" };
        }
      }
    }

    // input/textarea 字数校验
    if (
      (fieldType === "input" || fieldType === "textarea") &&
      value &&
      value.trim &&
      value.trim().length > 0
    ) {
      const trimmedValue = value.trim();
      const min = rules.min;
      const max = rules.max;

      if (min !== undefined && trimmedValue.length < min) {
        return {
          valid: false,
          message: `Please enter at least ${min} character${
            min > 1 ? "s" : ""
          }`,
        };
      }

      if (max !== undefined && trimmedValue.length > max) {
        return {
          valid: false,
          message: `Please enter no more than ${max} character${
            max > 1 ? "s" : ""
          }`,
        };
      }
    }

    // 文件数量上限校验
    if (fieldType === "upload" && rules.max !== undefined) {
      if (Array.isArray(value) && value.length > rules.max) {
        return {
          valid: false,
          message: `You can upload a maximum of ${rules.max} file${
            rules.max > 1 ? "s" : ""
          }`,
        };
      }
    }

    // 如果有校验规则名称，进行格式校验
    if (rulesName && value && value.trim && value.trim().length > 0) {
      const rule = FORM_VALIDATION_RULES[rulesName];
      // 如果规则存在才进行校验，否则跳过
      if (rule && rule.pattern) {
        if (!rule.pattern.test(value.trim())) {
          return { valid: false, message: rule.message };
        }
      }
    }

    // 验证通过
    return { valid: true, message: "" };
  };

  /**
   * 在表单内部显示错误提示
   * @param {HTMLElement} formElement - 表单容器元素
   * @param {string} message - 错误消息
   */
  const showFormError = (formElement, message) => {
    const errorContainer = formElement.querySelector("[data-form-error]");
    const errorMessage = formElement.querySelector("[data-form-error-message]");
    if (errorContainer && errorMessage) {
      errorMessage.textContent = message;
      errorContainer.style.display = "flex";
      // 滚动到错误提示位置（确保错误提示在表单底部、按钮上方可见）
      setTimeout(() => {
        // 先滚动到表单容器，然后确保错误提示在可视区域内
        const formFooter = formElement.querySelector(".chat-form-footer");
        if (formFooter) {
          formFooter.scrollIntoView({ behavior: "smooth", block: "nearest" });
        } else {
          errorContainer.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });
        }
      }, 100);
    }
  };

  /**
   * 隐藏表单错误提示
   * @param {HTMLElement} formElement - 表单容器元素
   */
  const hideFormError = (formElement) => {
    const errorContainer = formElement.querySelector("[data-form-error]");
    if (errorContainer) {
      errorContainer.style.display = "none";
    }
  };

  /**
   * 检查表单中是否有文件正在上传
   * @param {HTMLElement} formElement - 表单容器元素
   * @returns {boolean} 是否有文件正在上传
   */
  const hasUploadingFiles = (formElement) => {
    const uploadingStatuses = formElement.querySelectorAll(
      ".chat-form-file__status--uploading"
    );
    return uploadingStatuses.length > 0;
  };

  /**
   * 处理表单 Next 按钮点击
   * @param {HTMLElement} formElement - 表单容器元素
   */
  const handleFormNext = (formElement) => {
    const formId = formElement.getAttribute("data-form-id");
    if (formId !== FormState.currentFormId) {
      console.warn("[Form] Form ID mismatch");
      return;
    }

    // 检查是否有文件正在上传
    if (hasUploadingFiles(formElement)) {
      showFormError(formElement, "Please wait for file uploads to complete");
      // 滚动到错误提示位置
      scrollToBottom();
      return;
    }

    // 隐藏之前的错误提示
    hideFormError(formElement);

    const currentField = FormState.fields[FormState.currentStep];
    if (!currentField) return;

    // 获取当前字段元素
    const currentFieldEl = formElement.querySelector(
      `[data-field-index="${FormState.currentStep}"]`
    );
    if (!currentFieldEl) return;

    // 获取字段的 key 和 rules_name
    const fieldKey = currentFieldEl.getAttribute("data-field-key");
    const rulesName = currentFieldEl.getAttribute("data-rules-name");
    const fieldType = currentField.form_type || currentField.type;

    // 获取字段值
    let fieldValue = null;
    if (fieldType === "input") {
      const inputEl = currentFieldEl.querySelector("[data-field-input]");
      fieldValue = inputEl ? inputEl.value : "";
    } else if (fieldType === "textarea") {
      const textareaEl = currentFieldEl.querySelector("[data-field-textarea]");
      fieldValue = textareaEl ? textareaEl.value : "";
    } else if (fieldType === "radio") {
      const checkedRadio = currentFieldEl.querySelector(
        "[data-radio-input]:checked"
      );
      fieldValue = checkedRadio ? checkedRadio.value : null;
    } else if (fieldType === "upload") {
      // 从 DOM 中读取已上传的文件 URL 数组
      const fileList = currentFieldEl.querySelector("[data-file-list]");
      const fileItems = fileList
        ? fileList.querySelectorAll(".chat-form-file__item")
        : [];
      fieldValue = [];
      fileItems.forEach((item) => {
        const url = item.getAttribute("data-file-url");
        if (url) {
          fieldValue.push(url);
        }
      });
    }

    // 验证字段
    const validation = validateFormField(currentField, fieldValue, rulesName);
    if (!validation.valid) {
      console.warn("[Form] Field validation failed:", validation.message);
      // 在表单内部显示错误提示
      showFormError(formElement, validation.message);
      return;
    }

    // 验证通过，隐藏错误提示
    hideFormError(formElement);

    // 保存字段值
    FormState.formData[fieldKey] = fieldValue;

    // 标记当前字段为已完成
    currentFieldEl.classList.add("chat-form-field--completed");
    currentFieldEl.classList.remove("chat-form-field--hidden");

    // 禁用当前字段的输入
    const inputs = currentFieldEl.querySelectorAll(
      "input, textarea, button, [data-file-trigger]"
    );
    inputs.forEach((input) => {
      input.disabled = true;
      input.style.pointerEvents = "none";
    });

    // 移动到下一步
    FormState.currentStep++;

    // 显示下一个字段
    const nextFieldEl = formElement.querySelector(
      `[data-field-index="${FormState.currentStep}"]`
    );
    if (nextFieldEl) {
      nextFieldEl.classList.remove("chat-form-field--hidden");
    }

    // 更新步骤显示和按钮文本
    updateFormStep(
      formElement,
      FormState.currentStep + 1,
      FormState.fields.length
    );

    // 滚动到底部
    scrollToBottom();
  };

  /**
   * 处理表单 Submit 按钮点击
   * @param {HTMLElement} formElement - 表单容器元素
   */
  const handleFormSubmit = async (formElement) => {
    const formId = formElement.getAttribute("data-form-id");
    if (formId !== FormState.currentFormId) {
      console.warn("[Form] Form ID mismatch");
      return;
    }

    // 检查是否有文件正在上传
    if (hasUploadingFiles(formElement)) {
      showFormError(formElement, "Please wait for file uploads to complete");
      // 滚动到错误提示位置
      scrollToBottom();
      return;
    }

    const currentField = FormState.fields[FormState.currentStep];
    if (!currentField) return;

    // 获取当前字段元素
    const currentFieldEl = formElement.querySelector(
      `[data-field-index="${FormState.currentStep}"]`
    );
    if (!currentFieldEl) return;

    // 获取字段的 key 和 rules_name
    const fieldKey = currentFieldEl.getAttribute("data-field-key");
    const rulesName = currentFieldEl.getAttribute("data-rules-name");
    const fieldType = currentField.form_type || currentField.type;

    // 获取字段值
    let fieldValue = null;
    if (fieldType === "input") {
      const inputEl = currentFieldEl.querySelector("[data-field-input]");
      fieldValue = inputEl ? inputEl.value : "";
    } else if (fieldType === "textarea") {
      const textareaEl = currentFieldEl.querySelector("[data-field-textarea]");
      fieldValue = textareaEl ? textareaEl.value : "";
    } else if (fieldType === "radio") {
      const checkedRadio = currentFieldEl.querySelector(
        "[data-radio-input]:checked"
      );
      fieldValue = checkedRadio ? checkedRadio.value : null;
    } else if (fieldType === "upload") {
      // 从 DOM 中读取已上传的文件 URL 数组
      const fileList = currentFieldEl.querySelector("[data-file-list]");
      const fileItems = fileList
        ? fileList.querySelectorAll(".chat-form-file__item")
        : [];
      fieldValue = [];
      fileItems.forEach((item) => {
        const url = item.getAttribute("data-file-url");
        if (url) {
          fieldValue.push(url);
        }
      });
    }

    // 验证字段
    const validation = validateFormField(currentField, fieldValue, rulesName);
    if (!validation.valid) {
      console.warn("[Form] Field validation failed:", validation.message);
      // 在表单内部显示错误提示
      showFormError(formElement, validation.message);
      return;
    }

    // 保存最后一个字段值
    FormState.formData[fieldKey] = fieldValue;

    // 标记当前字段为已完成
    currentFieldEl.classList.add("chat-form-field--completed");

    // 禁用当前字段的输入
    const inputs = currentFieldEl.querySelectorAll(
      "input, textarea, button, [data-file-trigger]"
    );
    inputs.forEach((input) => {
      input.disabled = true;
      input.style.pointerEvents = "none";
    });

    // 获取按钮的 action 和 card_id
    const submitBtn = formElement.querySelector("[data-form-button]");
    const btnAction = submitBtn ? submitBtn.getAttribute("data-action") : null;
    const cardId = submitBtn
      ? submitBtn.getAttribute("data-card-id")
      : FormState.cardId;

    // 禁用提交按钮
    if (submitBtn) {
      submitBtn.disabled = true;
      const buttonText = submitBtn.querySelector("[data-button-text]");
      if (buttonText) {
        buttonText.textContent = "Submitting...";
      }
    }

    FormState.isSubmitting = true;

    // 发送表单数据到后端
    if (cardId && btnAction) {
      const success = await sendWebSocketMessage("information", {
        card_id: cardId,
        button_action: btnAction,
        card_data: FormState.cardData || {},
        form_data: FormState.formData,
      });

      if (success) {
        // 提交成功后重置按钮状态
        FormState.isSubmitting = false;
        if (submitBtn) {
          const buttonText = submitBtn.querySelector("[data-button-text]");
          if (buttonText) {
            buttonText.textContent = "Submit";
          }
          // 注意：提交成功后按钮保持禁用状态，因为表单已提交
        }
      } else {
        console.error("[Form] Form submission failed");
        // 恢复按钮状态
        if (submitBtn) {
          submitBtn.disabled = false;
          const buttonText = submitBtn.querySelector("[data-button-text]");
          if (buttonText) {
            buttonText.textContent = "Submit";
          }
        }
        FormState.isSubmitting = false;
      }
    } else {
      console.warn("[Form] Missing card_id or btn_action, cannot submit");
      FormState.isSubmitting = false;
    }
  };

  /**
   * 更新表单步骤显示
   * @param {HTMLElement} formElement - 表单容器元素
   * @param {number} currentStep - 当前步骤（从 1 开始）
   * @param {number} totalSteps - 总步骤数
   */
  const updateFormStep = (formElement, currentStep, totalSteps) => {
    const stepText = formElement.querySelector("[data-step-text]");
    const buttonText = formElement.querySelector("[data-button-text]");

    if (stepText) {
      stepText.textContent = `${currentStep}/${totalSteps}`;
    }

    if (buttonText) {
      // 如果是最后一步，显示 Submit，否则显示 Next
      buttonText.textContent = currentStep === totalSteps ? "Submit" : "Next";
    }
  };

  /**
   * 处理文件上传（表单字段）
   * @param {HTMLElement} fieldElement - 字段容器元素
   * @param {FileList} files - 文件列表
   */
  const handleFileUpload = async (fieldElement, files) => {
    if (!files || files.length === 0) return;

    const fileList = fieldElement.querySelector("[data-file-list]");
    const fileTrigger = fieldElement.querySelector("[data-file-trigger]");
    const fileInput = fieldElement.querySelector("[data-file-input]");

    if (!fileList) return;

    // 获取表单容器，用于显示错误提示
    const formContainer = fieldElement.closest("[data-form-container]");

    // 获取文件数量限制
    const maxFiles = parseInt(fieldElement.getAttribute("data-rules-max")) || 1;
    const currentFileCount = fileList.querySelectorAll(
      ".chat-form-file__item"
    ).length;

    // 检查是否超过数量限制
    const availableSlots = maxFiles - currentFileCount;
    if (availableSlots <= 0) {
      if (formContainer) {
        showFormError(
          formContainer,
          `You can upload a maximum of ${maxFiles} file${
            maxFiles > 1 ? "s" : ""
          }`
        );
      } else {
        showError(
          `You can upload a maximum of ${maxFiles} file${
            maxFiles > 1 ? "s" : ""
          }`,
          false
        );
        setTimeout(() => {
          hideError();
        }, 3000);
      }
      return;
    }

    // 判断是否允许视频（根据 accept 属性）
    const accept = fileInput ? fileInput.getAttribute("accept") || "" : "";
    const allowVideo = accept.includes("video");

    // 显示文件列表
    fileList.style.display = "block";

    // 添加文件项（只添加可用数量）
    const filesToAdd = Array.from(files).slice(0, availableSlots);

    for (const file of filesToAdd) {
      // 验证文件
      const validation = validateFile(file, allowVideo);
      if (!validation.valid) {
        if (formContainer) {
          showFormError(formContainer, validation.message);
        } else {
          showError(validation.message, false);
          setTimeout(() => {
            hideError();
          }, 3000);
        }
        continue;
      }

      // 创建文件项
      const fileItem = document.createElement("div");
      fileItem.className = "chat-form-file__item";
      fileItem.setAttribute("data-file-url", ""); // 初始为空，上传成功后填充

      const fileName = document.createElement("span");
      fileName.className = "chat-form-file__name";
      fileName.textContent = file.name;

      const statusSpan = document.createElement("span");
      statusSpan.className =
        "chat-form-file__status chat-form-file__status--uploading";

      // 创建上传动画图标
      const loadingIcon = document.createElement("span");
      loadingIcon.className = "chat-form-file__loading-icon";
      loadingIcon.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="2" stroke-dasharray="43.98" stroke-dashoffset="10.99" fill="none" opacity="0.3"/>
          <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="2" stroke-dasharray="43.98" stroke-dashoffset="32.99" fill="none" stroke-linecap="round"/>
        </svg>
      `;

      const loadingText = document.createTextNode(" Uploading...");
      statusSpan.appendChild(loadingIcon);
      statusSpan.appendChild(loadingText);
      statusSpan.style.color = "#666";
      statusSpan.style.fontSize = "1.2rem";
      statusSpan.style.marginLeft = "0.8rem";
      statusSpan.style.display = "flex";
      statusSpan.style.alignItems = "center";
      statusSpan.style.gap = "0.4rem";

      const removeBtn = document.createElement("button");
      removeBtn.className = "chat-form-file__remove";
      removeBtn.textContent = "Remove";
      removeBtn.type = "button";
      removeBtn.disabled = true; // 上传中禁用删除按钮
      removeBtn.addEventListener("click", () => {
        // 移除文件
        fileItem.remove();

        // 更新上传按钮显示状态
        const remainingFiles = fileList.querySelectorAll(
          ".chat-form-file__item"
        ).length;
        if (remainingFiles === 0) {
          fileList.style.display = "none";
        }
        if (remainingFiles < maxFiles && fileTrigger) {
          fileTrigger.style.display = "flex";
        }
      });

      fileItem.appendChild(fileName);
      fileItem.appendChild(statusSpan);
      fileItem.appendChild(removeBtn);
      fileList.appendChild(fileItem);

      // 上传文件
      try {
        const ossUrl = await uploadFileToServer(file, validation.fileType);

        // 保存 oss_url
        fileItem.setAttribute("data-file-url", ossUrl);

        // 更新状态 - 清空内容并显示成功图标
        statusSpan.innerHTML = "";
        statusSpan.textContent = "✓";
        statusSpan.style.color = "#4caf50";
        statusSpan.classList.remove("chat-form-file__status--uploading");
        removeBtn.disabled = false;

        // 文件上传成功后清除错误提示
        if (formContainer) {
          hideFormError(formContainer);
        }
      } catch (error) {
        console.error("[Form Upload] Upload failed:", error);

        // 更新状态为失败 - 清空内容并显示失败文本
        statusSpan.innerHTML = "";
        statusSpan.textContent = "Failed";
        statusSpan.style.color = "#f44336";
        statusSpan.classList.remove("chat-form-file__status--uploading");
        removeBtn.disabled = false;

        // 在表单内部显示错误提示
        if (formContainer) {
          showFormError(
            formContainer,
            `Failed to upload ${file.name}: ${error.message || "Unknown error"}`
          );
        } else {
          showError(
            `Failed to upload ${file.name}: ${
              error.message || "Unknown error"
            }`,
            false
          );
          setTimeout(() => {
            hideError();
          }, 3000);
        }
      }
    }

    // 更新上传按钮显示状态
    const totalFiles = fileList.querySelectorAll(
      ".chat-form-file__item"
    ).length;
    if (totalFiles >= maxFiles && fileTrigger) {
      // 达到上限，隐藏上传按钮
      fileTrigger.style.display = "none";
    }

    // 如果超过可用数量，显示提示
    if (files.length > availableSlots) {
      if (formContainer) {
        showFormError(
          formContainer,
          `Only ${availableSlots} file${
            availableSlots > 1 ? "s" : ""
          } can be added (maximum ${maxFiles})`
        );
      } else {
        showError(
          `Only ${availableSlots} file${
            availableSlots > 1 ? "s" : ""
          } can be added (maximum ${maxFiles})`,
          false
        );
        setTimeout(() => {
          hideError();
        }, 3000);
      }
    }
  };

  // ============================================
  // Error Handling
  // ============================================

  const handleInitError = (error) => {
    console.error("Chat initialization failed:", error);
    showError(ERROR_MESSAGES.INIT_FAILED, true);
    hideLoading();
    hideReconnectStatus();
    ChatState.isInitializing = false;
  };

  const handleConnectionError = (error) => {
    console.error("WebSocket connection error:", error);
    showError(ERROR_MESSAGES.WS_CONNECTION_FAILED, true);
    hideLoading();
    hideReconnectStatus();
    ChatState.wsState = WS_STATE.DISCONNECTED;
  };

  const retryInitialization = async () => {
    hideError();
    resetChatState();
    await performChatInitialization();
  };

  // ============================================
  // Chat Initialization Flow
  // ============================================

  const performChatInitialization = async (
    clearMessages = true,
    isReconnect = false
  ) => {
    if (ChatState.isInitializing || ChatState.isInitialized) {
      return;
    }

    ChatState.isInitializing = true;

    // 如果是重连场景，不显示全屏loading，而是显示轻量的连接状态提示
    if (isReconnect) {
      // 在消息区域顶部显示轻量的连接状态提示
      showReconnectStatus();
    } else {
      // 初次初始化时显示全屏loading
      showLoading();
    }

    hideError();

    try {
      // Step 1: 清空消息列表和重置状态（仅在首次初始化时清空）
      if (clearMessages) {
        const chatMessages = document.querySelector(".customer-chat__messages");
        if (chatMessages) {
          chatMessages.innerHTML = "";
        }
      }

      ChatState.displayedMessageIds.clear();

      // Step 2: 建立 WebSocket 连接
      // 连接成功后，后端会通过 WebSocket 推送欢迎语和 FAQ
      updateConnectionStatus("Connecting to chat...");
      connectWebSocket();

      // 注意：不在这里调用 hideLoading()，而是在握手成功后调用
      // 注意：isInitialized 不在 here 设置，而是在握手成功后设置，以便在 sendHandshakeMessage 中正确判断是否是初次建联
      ChatState.isInitializing = false;
    } catch (error) {
      handleInitError(error);
    }
  };

  // ============================================
  // UI Interaction - Chat Panel Toggle
  // ============================================

  const customerChat = () => {
    const chatContainer = document.querySelector(".customer-chat");
    const chatTrigger = document.querySelector(".customer-chat__trigger");
    const chatPanel = document.querySelector(".customer-chat__panel");
    const chatCloseMobile = document.querySelector(
      ".customer-chat__close-mobile"
    );
    const chatInput = document.querySelector(".customer-chat__input");

    if (!chatContainer || !chatTrigger || !chatPanel) {
      return;
    }

    const handleScroll = () => {
      if (chatContainer.classList.contains("active")) {
        chatTrigger.classList.add("show");
        return;
      }

      // 调整显示阈值，让按钮更早显示（更灵敏）
      // 原来需要滚动超过整个视口高度，现在只需要滚动超过视口高度的 30% 就显示
      const threshold = document.documentElement.clientHeight * 0.3;
      if (window.scrollY > threshold) {
        chatTrigger.classList.add("show");
      } else {
        chatTrigger.classList.remove("show");
      }
    };

    const throttle = (func, delay) => {
      let lastCall = 0;
      return function (...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
          return;
        }
        lastCall = now;
        return func(...args);
      };
    };

    const toggleChat = async () => {
      const wasActive = chatContainer.classList.contains("active");

      chatContainer.classList.toggle("active");

      if (chatContainer.classList.contains("active")) {
        chatTrigger.classList.add("show");

        if (!ChatState.isInitialized && !ChatState.isInitializing) {
          await performChatInitialization();
        }

        if (window.innerWidth >= 768) {
          setTimeout(() => {
            chatInput?.focus();
          }, 300);
        }
      } else {
        handleScroll();
      }
    };

    const closeChat = () => {
      chatContainer.classList.remove("active");
      handleScroll();
    };

    const preventPanelClose = (e) => {
      e.stopPropagation();
    };

    window.addEventListener("scroll", throttle(handleScroll, 100));
    chatTrigger.addEventListener("click", toggleChat);
    chatPanel.addEventListener("click", preventPanelClose);

    if (chatCloseMobile) {
      chatCloseMobile.addEventListener("click", closeChat);
    }

    handleScroll();

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && chatContainer.classList.contains("active")) {
        closeChat();
      }
    });

    const retryButton = document.querySelector(".customer-chat__error-retry");
    if (retryButton) {
      retryButton.addEventListener("click", retryInitialization);
    }
  };

  customerChat();

  document.addEventListener("shopify:section:load", function () {
    customerChat();
  });

  // ============================================
  // Chat Message Interactions
  // ============================================

  /**
   * 处理工作台上传图片
   * @param {File} file - 图片文件
   */
  const handleWorkbenchImageUpload = async (file) => {
    // 验证图片文件
    const validation = validateFile(file, false);
    if (!validation.valid) {
      showError(validation.message, false);
      setTimeout(() => {
        hideError();
      }, 3000);
      return;
    }

    try {
      // 检查连接状态，如果未初始化（正常关闭后），先重新初始化
      // 注意：重连时不显示全屏loading，而是显示轻量的重连状态提示
      if (!ChatState.isInitialized && !ChatState.isInitializing) {
        // 传入 true，表示这是重连场景，使用轻量的连接状态提示
        await performChatInitialization(false, true);
        // 等待连接建立（最多等待5秒）
        let waitCount = 0;
        while (
          (!ChatState.ws || ChatState.ws.readyState !== WebSocket.OPEN) &&
          waitCount < 50
        ) {
          await new Promise((resolve) => setTimeout(resolve, 100));
          waitCount++;
        }
        // 如果连接仍未建立，显示错误
        if (!ChatState.ws || ChatState.ws.readyState !== WebSocket.OPEN) {
          hideReconnectStatus();
          showError("Connection failed, please try again", false);
          setTimeout(() => {
            hideError();
          }, 3000);
          return;
        }
      }

      // 上传文件（在连接建立后）
      const ossUrl = await uploadFileToServer(file, validation.fileType);

      // 发送图片消息给后端
      const success = await sendWebSocketMessage(WS_MESSAGE_TYPE.MESSAGE, {
        image: ossUrl,
        query: "", // 后端要求必传
      });

      if (success) {
        // 立即显示用户上传的图片消息
        addMessage("user", "image", {
          imageUrl: ossUrl,
          imageAlt: file.name || "Uploaded image",
          timestamp: Date.now(), // 使用当前时间戳
        });
      } else {
        showError("Failed to send image message", false);
        setTimeout(() => {
          hideError();
        }, 3000);
      }
    } catch (error) {
      hideLoading();
      console.error("[Workbench Upload] Upload failed:", error);
      showError(
        error.message || "Failed to upload image, please try again",
        false
      );
      setTimeout(() => {
        hideError();
      }, 3000);
    }
  };

  const chatMessageInteractions = () => {
    const chatMessages = document.querySelector(".customer-chat__messages");
    const chatInput = document.querySelector(".customer-chat__input");
    const sendBtn = document.querySelector(".customer-chat__send-btn");
    const uploadBtn = document.querySelector(".customer-chat__upload-btn");
    const uploadInput = document.querySelector(".customer-chat__upload-input");

    if (!chatMessages) return;

    // 控制发送按钮显示/隐藏
    const toggleSendBtn = () => {
      if (!chatInput || !sendBtn) return;
      const hasContent = chatInput.value.trim().length > 0;

      if (hasContent) {
        sendBtn.style.display = "flex";
      } else {
        sendBtn.style.display = "none";
      }
    };

    if (chatInput && sendBtn) {
      // 监听输入事件
      chatInput.addEventListener("input", toggleSendBtn);
    }

    const handleFaqClick = (e) => {
      const button = e.target.closest(".chat-message-faq__button");
      if (!button) return;

      const questionList = button.getAttribute("data-question").split('_');
      const cardId = button.getAttribute("data-question-card-id");
      const originalMessage = ChatState.faqMessages.get(cardId);
      
      const result = findQuestion(originalMessage, questionList[questionList.length - 1]);

      if (result && result.length > 0) {
        nextQuestion(result, cardId)
      } else {
        const currentFaqDom = document.querySelector(
          `[data-card-id="${cardId}"]`
        );

        if (currentFaqDom) {
          const messageWrapper = currentFaqDom.closest(".chat-message");
          if (messageWrapper) {
            messageWrapper.remove();
          } else {
            currentFaqDom.remove();
          }
        }
        sendUserMessage(questionList[questionList.length - 1]);
      }

      function findQuestion(originalMessage, question) {
        // 参数验证
        if (!originalMessage || !Array.isArray(originalMessage)) {
          console.warn("[findQuestion] Invalid originalMessage parameter");
          return null;
        }

        if (!question || typeof question !== 'string') {
          console.warn("[findQuestion] Invalid question parameter");
          return null;
        }

        // 遍历当前层级的每一项
        for (let i = 0; i < originalMessage.length; i++) {
          const item = originalMessage[i];
          
          if (!item || typeof item !== 'object') {
            continue;
          }

          // 如果当前项的 text 匹配 question，返回该项的 questions
          if (item.text === question) {
            // 返回 questions 数组，如果不存在则返回空数组
            return item.questions && Array.isArray(item.questions) ? item.questions : [];
          }

          // 如果当前项有 questions 子数组，递归查找
          if (item.questions && Array.isArray(item.questions) && item.questions.length > 0) {
            const result = findQuestion(item.questions, question);
            // 如果在子数组中找到了，直接返回结果
            if (result !== null) {
              return result;
            }
          }
        }

        // 如果遍历完所有项都没找到，返回 null
        return null;
      }

      function nextQuestion(questions, cardId) {
        const currentFaqDom = document.querySelector(`[data-card-id="${cardId}"]`);
        const itemTemplate = currentFaqDom.querySelector(".chat-message-faq__item").cloneNode(true);
        console.log(itemTemplate)
        const questionsContainer = currentFaqDom.querySelector("[data-questions-target]");
        questionsContainer.innerHTML = "";

        questions.forEach((qusItem, index) => {
          const itemClone = itemTemplate.cloneNode(true);
          const textEl = itemClone.querySelector("[data-question-text]");
          const buttonEl = itemClone.querySelector("button");
          if (textEl) textEl.textContent = qusItem.text;
          buttonEl.getAttribute("data-question")
          const buttonAttr = `${buttonEl.getAttribute("data-question")}_${qusItem.text}`
          buttonEl.setAttribute("data-question", buttonAttr);
          buttonEl.setAttribute("data-question-id", `faq_${index}`);
          questionsContainer.appendChild(itemClone);
        });

        const cardEl = currentFaqDom.querySelector("[data-card-id]");
        if (cardEl && data.cardId) {
          cardEl.setAttribute("data-card-id", data.cardId);
        }

        // 移除模板元素
        itemTemplate.remove();
      }

      // if (!question) return;

      // 发送用户消息
      // sendUserMessage(question);
    };

    const handleConfirmClick = async (e) => {
      const button = e.target.closest(".chat-message-confirm__button");
      if (!button) return;

      // 如果已经禁用，不处理
      if (button.disabled) return;

      // 获取按钮的 action
      const action = button.getAttribute("data-action");
      if (!action) {
        console.warn("[Confirm] Button has no action");
        return;
      }

      // 获取消息容器上的卡片数据
      const confirmContainer = button.closest("[data-confirm-container]");
      if (!confirmContainer) {
        console.warn("[Confirm] Cannot find confirm container");
        return;
      }

      const cardId = confirmContainer.getAttribute("data-card-id");
      const cardDataStr = confirmContainer.getAttribute("data-card-data");
      let cardData = {};

      try {
        cardData = cardDataStr ? JSON.parse(cardDataStr) : {};
      } catch (error) {
        console.error("[Confirm] Failed to parse card_data:", error);
      }

      // 发送消息给后端
      const success = await sendWebSocketMessage("confirm", {
        card_id: cardId,
        button_action: action,
        card_data: cardData,
      });

      // 发送成功后，禁用所有按钮并添加选中态
      if (success) {
        const buttonsContainer = button.closest(
          ".chat-message-confirm__buttons"
        );

        if (buttonsContainer) {
          const allButtons = buttonsContainer.querySelectorAll(
            ".chat-message-confirm__button"
          );

          allButtons.forEach((btn) => {
            if (btn === button) {
              btn.classList.add("chat-message-confirm__button--selected");
            } else {
              btn.remove();
            }
          });
        } else {
          button.classList.add("chat-message-confirm__button--selected");
        }
      }
    };

    const sendUserMessage = async (content, messageElement = null) => {
      if (!content || !content.trim()) return;

      let messageEl = messageElement;

      // 如果是重发，使用现有消息元素；否则创建新消息
      if (!messageEl) {
        // 生成临时消息ID用于定位
        const tempId = `temp-${Date.now()}-${Math.random()
          .toString(36)
          .substr(2, 9)}`;

        // 立即显示用户消息（显示为发送中状态）
        addMessage("user", "text", {
          content: content,
          tempId: tempId, // 传递临时ID
          timestamp: Date.now(), // 使用当前时间戳
        });

        // 通过临时ID获取刚添加的消息元素
        messageEl = document.querySelector(`[data-temp-id="${tempId}"]`);
        if (messageEl) {
          // 移除临时ID
          messageEl.removeAttribute("data-temp-id");
        } else {
          // 如果找不到，使用最后一条消息作为后备方案
          const messages = document.querySelectorAll(".chat-message--user");
          messageEl = messages[messages.length - 1];
        }
      }

      // 如果是重发，移除失败状态
      if (messageEl) {
        messageEl.classList.remove("chat-message--failed");
        const retryBtn = messageEl.querySelector("[data-retry-btn]");
        if (retryBtn) retryBtn.style.display = "none";
      }

      // 检查网络与连接状态
      const isNetworkOffline = !navigator.onLine;
      const isWebSocketUnavailable =
        !ChatState.ws ||
        ChatState.ws.readyState === WebSocket.CLOSED ||
        ChatState.ws.readyState === WebSocket.CLOSING;
      
      // 如果断网或连接不可用，在 chat-message__content 下添加 sending 字样
      if (messageEl && (isNetworkOffline || isWebSocketUnavailable)) {
        const contentEl = messageEl.querySelector(".chat-message__content");
        if (contentEl) {
          // 检查是否已经存在 sending 元素，避免重复添加
          let sendingEl = contentEl.querySelector(".chat-message__sending");
          if (!sendingEl) {
            sendingEl = document.createElement("div");
            sendingEl.className = "chat-message__sending";
            sendingEl.textContent = "sending";
            contentEl.appendChild(sendingEl);
            // 添加 sending 元素后，滚动到底部以显示完整内容
            setTimeout(() => {
              scrollToBottom(true);
            }, 100);
          }
        }
      }

      // 如果断网，直接返回，不尝试发送
      if (isNetworkOffline) {
        // 将消息加入队列，等待网络恢复后自动发送
        const clientMessageId = `client-${Date.now()}-${Math.random()
          .toString(36)
          .substr(2, 9)}`;
        const messageData = {
          query: content,
          clientMessageId: clientMessageId,
        };
        ChatState.messageQueue.push({
          type: WS_MESSAGE_TYPE.MESSAGE,
          data: messageData,
        });
        
        // 添加到待确认列表，以便收到确认时能找到消息元素并移除 sending
        ChatState.pendingMessages.set(clientMessageId, {
          content: content,
          timestamp: Date.now(),
          messageElement: messageEl,
        });
        
        if (messageEl) {
          messageEl.setAttribute("data-message-id", clientMessageId);
        }
        
        // 确保滚动到底部以显示 sending 元素
        setTimeout(() => {
          scrollToBottom(true);
        }, 100);
        
        return;
      }

      // 检查连接状态，如果未初始化（正常关闭后），先重新初始化并等待连接成功
      if (!ChatState.isInitialized && !ChatState.isInitializing) {
        // 传入 true，表示这是重连场景，使用轻量的连接状态提示
        await performChatInitialization(false, true);

        // 等待连接建立（最多等待5秒）
        let waitCount = 0;
        while (
          (!ChatState.ws || ChatState.ws.readyState !== WebSocket.OPEN) &&
          waitCount < 50
        ) {
          await new Promise((resolve) => setTimeout(resolve, 100));
          waitCount++;
        }

        // 如果连接仍未建立，显示失败状态
        if (!ChatState.ws || ChatState.ws.readyState !== WebSocket.OPEN) {
          if (messageEl) {
            messageEl.classList.add("chat-message--failed");
            const retryBtn = messageEl.querySelector("[data-retry-btn]");
            if (retryBtn) retryBtn.style.display = "flex";
            // 保存消息内容到元素，用于重发
            messageEl.setAttribute("data-message-content", content);
            // 如果断网，确保显示 sending 元素
            const contentEl = messageEl.querySelector(".chat-message__content");
            if (contentEl && !navigator.onLine) {
              let sendingEl = contentEl.querySelector(".chat-message__sending");
              if (!sendingEl) {
                sendingEl = document.createElement("div");
                sendingEl.className = "chat-message__sending";
                sendingEl.textContent = "sending";
                contentEl.appendChild(sendingEl);
              }
            }
          }
          showError("Connection failed, please try again", false);
          setTimeout(() => {
            hideError();
          }, 3000);
          return;
        }
      }

      // 生成客户端消息 ID
      const clientMessageId = `client-${Date.now()}-${Math.random()
        .toString(36)
        .substr(2, 9)}`;

      // 构建消息数据（符合后端要求的格式）
      const messageData = {
        query: content, // 后端要求使用 query 字段
        clientMessageId: clientMessageId,
      };

      // 通过 WebSocket 发送（此时连接已建立）
      const success = await sendWebSocketMessage(
        WS_MESSAGE_TYPE.MESSAGE,
        messageData
      );

      if (success) {
        // 加入待确认列表
        ChatState.pendingMessages.set(clientMessageId, {
          content: content,
          timestamp: Date.now(),
          messageElement: messageEl, // 保存消息元素引用，用于后续状态更新
        });

        // 标记消息为发送中，并确保移除失败状态
        if (messageEl) {
          messageEl.setAttribute("data-message-id", clientMessageId);
          messageEl.classList.remove("chat-message--failed");
          const retryBtn = messageEl.querySelector("[data-retry-btn]");
          if (retryBtn) retryBtn.style.display = "none";
          // 移除 sending 元素（如果存在）
          const contentEl = messageEl.querySelector(".chat-message__content");
          if (contentEl) {
            const sendingEl = contentEl.querySelector(".chat-message__sending");
            if (sendingEl) {
              sendingEl.remove();
            }
          }
        }
      } else {
        // 发送失败（可能是连接在发送时断开了）
        // 将消息加入队列，等待连接恢复后自动发送
        ChatState.messageQueue.push({
          type: WS_MESSAGE_TYPE.MESSAGE,
          data: messageData,
        });

        // 标记消息为发送中状态，等待队列自动发送
        if (messageEl) {
          messageEl.setAttribute("data-message-id", clientMessageId);
          messageEl.classList.remove("chat-message--failed");
          const retryBtn = messageEl.querySelector("[data-retry-btn]");
          if (retryBtn) retryBtn.style.display = "none";
          // 如果断网，确保显示 sending 元素
          const isOfflineNow = !navigator.onLine || 
            (!ChatState.ws || ChatState.ws.readyState === WebSocket.CLOSED || ChatState.ws.readyState === WebSocket.CLOSING);
          if (isOfflineNow) {
            const contentEl = messageEl.querySelector(".chat-message__content");
            if (contentEl) {
              let sendingEl = contentEl.querySelector(".chat-message__sending");
              if (!sendingEl) {
                sendingEl = document.createElement("div");
                sendingEl.className = "chat-message__sending";
                sendingEl.textContent = "sending";
                contentEl.appendChild(sendingEl);
                // 添加 sending 元素后，滚动到底部以显示完整内容
                setTimeout(() => {
                  scrollToBottom(true);
                }, 100);
              }
            }
          }
        }

        // 显示连接丢失提示
        showError(ERROR_MESSAGES.WS_CONNECTION_LOST, false);
      }
    };

    const handleSendMessage = () => {
      if (!chatInput) return;

      const message = chatInput.value.trim();
      if (!message) return;

      sendUserMessage(message);
      chatInput.value = "";
      toggleSendBtn();
    };

    const handleFormButtonClick = (e) => {
      const button = e.target.closest("[data-form-button]");
      if (!button) return;

      const formContainer = button.closest("[data-form-container]");
      if (!formContainer) return;

      const buttonText = button.querySelector("[data-button-text]");
      const isSubmit = buttonText && buttonText.textContent === "Submit";

      if (isSubmit) {
        handleFormSubmit(formContainer);
      } else {
        handleFormNext(formContainer);
      }
    };

    const handleFileUploadClick = (e) => {
      const trigger = e.target.closest("[data-file-trigger]");
      if (!trigger) return;

      const fieldElement = trigger.closest(".chat-form-field");
      if (!fieldElement) return;

      const fileInput = fieldElement.querySelector("[data-file-input]");
      if (fileInput) {
        fileInput.click();
      }
    };

    const handleFileInputChange = async (e) => {
      const fileInput = e.target;
      if (!fileInput.matches("[data-file-input]")) return;

      const fieldElement = fileInput.closest(".chat-form-field");
      if (!fieldElement) return;

      await handleFileUpload(fieldElement, fileInput.files);

      // 清空 input，允许重复上传同一文件
      fileInput.value = "";
    };

    const handleRetryClick = (e) => {
      const retryBtn = e.target.closest("[data-retry-btn]");
      if (!retryBtn) return;

      const messageEl = retryBtn.closest(".chat-message--user");
      if (!messageEl) return;

      const content = messageEl.getAttribute("data-message-content");
      if (!content) return;

      // 重发消息
      sendUserMessage(content, messageEl);
    };

    chatMessages.addEventListener("click", (e) => {
      handleFaqClick(e);
      handleConfirmClick(e);
      handleFormButtonClick(e);
      handleFileUploadClick(e);
      handleRetryClick(e);
    });

    chatMessages.addEventListener("change", handleFileInputChange);

    if (sendBtn) {
      sendBtn.addEventListener("click", handleSendMessage);
    }

    if (chatInput) {
      chatInput.addEventListener("keypress", (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
          e.preventDefault();
          handleSendMessage();
        }
      });
    }

    // 工作台上传按钮事件
    if (uploadBtn && uploadInput) {
      // 点击上传按钮，触发文件选择
      uploadBtn.addEventListener("click", () => {
        uploadInput.click();
      });

      // 文件选择后，上传文件
      uploadInput.addEventListener("change", (e) => {
        const file = e.target.files?.[0];
        if (file) {
          handleWorkbenchImageUpload(file);
          // 清空 input，允许重复上传同一文件
          uploadInput.value = "";
        }
      });
    }
  };

  chatMessageInteractions();

  document.addEventListener("shopify:section:load", function () {
    chatMessageInteractions();
  });

  // ============================================
  // Page Lifecycle Management
  // ============================================

  window.addEventListener("beforeunload", () => {
    closeWebSocket();
  });

  document.addEventListener("visibilitychange", () => {
    if (!document.hidden) {
      // 页面显示时检查连接状态
      if (
        ChatState.isInitialized &&
        ChatState.wsState === WS_STATE.DISCONNECTED
      ) {
        connectWebSocket();
      }
    }
  });

  // 网络状态变化
  window.addEventListener("online", () => {
    // 移除所有消息的 sending 元素
    const sendingElements = document.querySelectorAll(".chat-message__sending");
    sendingElements.forEach((el) => el.remove());

    if (
      ChatState.isInitialized &&
      ChatState.wsState === WS_STATE.DISCONNECTED
    ) {
      connectWebSocket();
    }
  });

  window.addEventListener("offline", () => {
    showError("Network anomaly, offline", false);
    // 主动关闭 WebSocket 连接，因为网络已离线
    // 这样可以立即响应网络断开，而不是等待心跳超时
    if (ChatState.ws && ChatState.ws.readyState === WebSocket.OPEN) {
      ChatState.ws.close(1006, "Network offline"); // 1006 表示异常关闭
    }
    // 停止重连尝试，因为网络已离线
    stopReconnect();
  });
})();
